

// import React, { useState, useEffect } from "react";
// import { Header } from "../../Header";
// import CircularProgress from "@mui/material/CircularProgress";
// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import Grid from "@mui/material/Grid";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import isoWeek from "dayjs/plugin/isoWeek";
// import Pagination from "@mui/material/Pagination";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import Button from "@mui/material/Button";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import IconButton from "@mui/material/IconButton";
// import "../Reports.css";
// import { local_signage, local_url } from "../../Const";
// import { saveAs } from "file-saver";
// import { Tooltip } from "@mui/material";

// dayjs.extend(isoWeek);

// const SaleWeeklySummary = () => {
//     const [areas, setAreas] = useState([]);
//     const [area, setArea] = useState("ALL");
//     const [startDate, setStartDate] = useState(dayjs());
//     const [endDate, setEndDate] = useState(dayjs());
//     const [type, setType] = useState("ALL");
//     const [page, setPage] = useState(1);
//     const [loading, setLoading] = useState(false);
//     const [tableData, setTableData] = useState([]);
//     const [error, setError] = useState(null);
//     const [areasLoading, setAreasLoading] = useState(true);
//     const userId = localStorage.getItem('userId');
//     const rowsPerPage = 200;
//     const [selectedDivision, setSelectedDivision] = useState("POULTRY");
//     const [expandedAreas, setExpandedAreas] = useState([]);
//     const [expandedData, setExpandedData] = useState({});
//     const [rawData, setRawData] = useState([]);
//     const [expandedKeys, setExpandedKeys] = useState([]);
//     const [expandedBranchKeys, setExpandedBranchKeys] = useState([]);
//     const [expandedItemData, setExpandedItemData] = useState({});
//     const [isValidRange, setIsValidRange] = useState(true);
//     const [highlightedDays, setHighlightedDays] = useState([]);
//     const today = dayjs();


    // const transformWeeklyData = (data, startDate, endDate) => {
    //     if (!Array.isArray(data) || data.length === 0) return [];
        
    //     const start = dayjs(startDate);
    //     const end = dayjs(endDate);
        
    //     // Group dates into weeks based on business dates
    //     const dateToWeekMap = {};
    //     let currentWeek = 1;
    //     let weekStartDate = start;
        
    //     while (weekStartDate.isBefore(end) || weekStartDate.isSame(end, 'day')) {
    //         const weekEndDate = weekStartDate.add(6, 'day');
            
    //         let currentDate = weekStartDate;
    //         while ((currentDate.isBefore(weekEndDate) || currentDate.isSame(weekEndDate, 'day')) && 
    //                (currentDate.isBefore(end) || currentDate.isSame(end, 'day'))) {
    //             dateToWeekMap[currentDate.format('YYYY-MM-DD')] = currentWeek;
    //             currentDate = currentDate.add(1, 'day');
    //         }
            
    //         weekStartDate = weekStartDate.add(7, 'day');
    //         currentWeek++;
    //     }
        
    //     const maxWeek = currentWeek - 1;
    //     const weeksList = Array.from({ length: maxWeek }, (_, i) => i + 1);
        
    //     const channelMapping = {
    //         "APP": "Online",
    //         "WEB": "Online",
    //         "POS": "Offline",
    //         "CAL": "Offline",
    //         "GT": "GT / MT",
    //         "MT": "GT / MT",
    //         "MP": "MP"
    //     };
    
    //     // Filter data based on division and type (sales channel)
    //     const filteredData = data.filter(item => {
    //         const divisionMatch = selectedDivision === "ALL" ? true : 
    //             selectedDivision === "PRODUCT" ? item.Division === "PRODUCT" :
    //             selectedDivision === "NONPOULTRY" ? item.Division === "NONPOULTRY" :
    //             item.Division === selectedDivision;
    
    //         const channelCategory = channelMapping[item.SalesChannel] || "Others";
    //         const channelMatch = type === "ALL" ? true : 
    //             type === "Online" ? ["APP", "WEB"].includes(item.SalesChannel) :
    //             type === "Offline" ? ["POS", "CAL"].includes(item.SalesChannel) :
    //             type === "GT / MT" ? ["GT", "MT"].includes(item.SalesChannel) :
    //             type === item.SalesChannel;
    
    //         return divisionMatch && channelMatch;
    //     });
        
    //     // Rest of the transform logic remains the same...
    //     const groupedData = filteredData.reduce((acc, item) => {
    //         const businessDate = dayjs(item.BusinessDate);
    //         const formattedBusinessDate = businessDate.format('YYYY-MM-DD');
    //         const weekNum = dateToWeekMap[formattedBusinessDate];
            
    //         if (!weekNum) return acc;
            
    //         const division = item.Division;
    //         const category = channelMapping[item.SalesChannel] || "Others";
    //         const key = selectedDivision === "ALL" 
    //             ? `${item.Area}-${division}-${category}`
    //             : `${item.Area}-${category}`;
            
    //         if (!acc[key]) {
    //             acc[key] = {
    //                 CITYID: item.Area,
    //                 AREANAME: item.AreaName,
    //                 Division: division,
    //                 Category: category,
    //                 weeks: {}
    //             };
    //         }
            
    //         const qty = parseFloat(item.Qty) || 0;
    //         const returnQty = parseFloat(item.ReturnQty) || 0;
    //         const netQty = Math.max(0, qty - returnQty);
            
    //         acc[key].weeks[weekNum] = (acc[key].weeks[weekNum] || 0) + netQty;
            
    //         return acc;
    //     }, {});
    
    //     return Object.values(groupedData)
    //         .map(data => {
    //             const result = {
    //                 CITYID: data.CITYID,
    //                 AREANAME: data.AREANAME,
    //                 Division: data.Division,
    //                 Category: data.Category,
    //             };
                
    //             weeksList.forEach(weekNum => {
    //                 result[`Week ${weekNum}`] = Number(data.weeks[weekNum] || 0).toFixed(2);
    //             });
                
    //             const lastWeek = Math.max(...weeksList);
    //             const prevWeek = lastWeek - 1;
                
    //             const lastVal = Number(data.weeks[lastWeek] || 0);
    //             const prevVal = Number(data.weeks[prevWeek] || 0);
                
    //             result.DIFF = (lastVal - prevVal).toFixed(2);
                
    //             if (prevVal === 0) {
    //                 result.MOM = lastVal > 0 ? "100.00" : "0.00";
    //             } else {
    //                 result.MOM = ((lastVal - prevVal) / prevVal * 100).toFixed(2);
    //             }
                
    //             return result;
    //         })
    //         .filter(item => weeksList.some(week => parseFloat(item[`Week ${week}`]) > 0))
    //         .sort((a, b) => {
    //             if (selectedDivision === "ALL") {
    //                 const divisionOrder = { 
    //                     "POULTRY": 1, 
    //                     "EGG": 2, 
    //                     "NONPOULTRY": 3, 
    //                     "PRODUCT": 4,
    //                     "RTC": 5 
    //                 };
    //                 if (a.Division !== b.Division) {
    //                     return divisionOrder[a.Division] - divisionOrder[b.Division];
    //                 }
    //             }
    //             if (a.AREANAME !== b.AREANAME) {
    //                 return a.AREANAME.localeCompare(b.AREANAME);
    //             }
    //             if (a.Category === "Online" && b.Category !== "Online") return -1;
    //             if (b.Category === "Online" && a.Category !== "Online") return 1;
                
    //             const categoryOrder = { "Online": 1, "Offline": 2, "GT / MT": 3, "MP": 4 };
    //             return categoryOrder[a.Category] - categoryOrder[b.Category];
    //         });
    // };

//     const validateDateRange = (start, end) => {
//     if (!dayjs.isDayjs(start) || !dayjs.isDayjs(end)) {
//       setIsValidRange(false);
//       return;
//     }

//     const daysDifference = end.diff(start, 'day');
//     const today = dayjs();

//     // Clear previous error
//     setError('');
    
//     // Validate the date range
//     if (end.isAfter(today)) {
//       setError('End date cannot be later than today');
//       setIsValidRange(false);
//     }
//     else if (daysDifference > 35) {
//       setError('Date range cannot exceed 35 days');
//       setIsValidRange(false);
//     }
//     else if (start.isAfter(end)) {
//       setError('Start date cannot be after end date');
//       setIsValidRange(false);
//     }
//     else {
//       setIsValidRange(true);
//     }
//   };

//   useEffect(() => {
//     validateDateRange(startDate, endDate);
//   }, [startDate, endDate]);

//   const handleStartDateChange = (newValue) => {
//     if (dayjs.isDayjs(newValue) && newValue.isValid()) {
//       setStartDate(newValue);
//       validateDateRange(newValue, endDate);
//     }
//   };

//   const handleEndDateChange = (newValue) => {
//     if (dayjs.isDayjs(newValue) && newValue.isValid()) {
//       setEndDate(newValue);
//       validateDateRange(startDate, newValue);
//     }
//   };


// // Updated handleBranchClick function
// const handleBranchClick = (BranchName, salesChannel, areaCode, category, division) => {
//     const compositeKey = `${BranchName}-${salesChannel}-${areaCode}-${category}-${division}`;
    
//     const isExpanded = expandedBranchKeys.includes(compositeKey);
    
//     if (isExpanded) {
//         setExpandedBranchKeys(prev => prev.filter(k => k !== compositeKey));
//     } else {
//         const itemData = transformItemData(
//             rawData, 
//             startDate, 
//             endDate, 
//             BranchName, 
//             salesChannel, 
//             areaCode, 
//             category, 
//             division
//         );
        
//         setExpandedItemData(prev => ({
//             ...prev,
//             [compositeKey]: itemData
//         }));
//         setExpandedBranchKeys(prev => [...prev, compositeKey]);
//     }
// };

// // Updated transformItemData function

// const transformItemData = (data, startDate, endDate, BranchName, salesChannel, areaCode, category, division) => {
//     const start = dayjs(startDate);
//     const end = dayjs(endDate);
    
//     // Create week mapping
//     const dateToWeekMap = {};
//     let currentWeek = 1;
//     let weekStartDate = start;
    
//     while (weekStartDate.isBefore(end) || weekStartDate.isSame(end, 'day')) {
//         const weekEndDate = weekStartDate.add(6, 'day');
//         let currentDate = weekStartDate;
//         while ((currentDate.isBefore(weekEndDate) || currentDate.isSame(weekEndDate, 'day')) && 
//                (currentDate.isBefore(end) || currentDate.isSame(end, 'day'))) {
//             dateToWeekMap[currentDate.format('YYYY-MM-DD')] = currentWeek;
//             currentDate = currentDate.add(1, 'day');
//         }
//         weekStartDate = weekStartDate.add(7, 'day');
//         currentWeek++;
//     }

//     const maxWeek = currentWeek - 1;
//     const weeksList = Array.from({ length: maxWeek }, (_, i) => i + 1);

//     // Filter data based on all criteria
//     const filteredData = data.filter(item => {
//         const matchesBranch = item.BranchName === BranchName;
//         const matchesChannel = item.SalesChannel === salesChannel;
//         const matchesArea = item.Area === areaCode;
//         const matchesDivision = division === "ALL" ? true : 
//             division === "PRODUCT" ? item.Division === "PRODUCT" :
//             item.Division === division;

//         return matchesBranch && matchesChannel && matchesArea && matchesDivision;
//     });

//     const groupedData = filteredData.reduce((acc, item) => {
//         const businessDate = dayjs(item.BusinessDate);
//         const formattedBusinessDate = businessDate.format('YYYY-MM-DD');
//         const weekNum = dateToWeekMap[formattedBusinessDate];
        
//         if (!weekNum) return acc;

//         const key = `${item.ItemId}-${item.itemname}`;
        
//         if (!acc[key]) {
//             acc[key] = {
//                 ItemName: item.itemname,
//                 ItemId: item.ItemId,
//                 Division: item.Division,
//                 SalesChannel: item.SalesChannel,
//                 weeks: {}
//             };
//         }
        
//         const qty = parseFloat(item.Qty) || 0;
//         const returnQty = parseFloat(item.ReturnQty) || 0;
//         const netQty = Math.max(0, qty - returnQty);
        
//         acc[key].weeks[weekNum] = (acc[key].weeks[weekNum] || 0) + netQty;
        
//         return acc;
//     }, {});

//     return Object.values(groupedData)
//         .map(data => {
//             const result = {
//                 ItemName: data.ItemName,
//                 ItemId: data.ItemId,
//                 Division: data.Division,
//                 SalesChannel: data.SalesChannel
//             };
            
//             weeksList.forEach(weekNum => {
//                 result[`Week ${weekNum}`] = Number(data.weeks[weekNum] || 0).toFixed(2);
//             });
            
//             const lastWeek = maxWeek;
//             const prevWeek = lastWeek - 1;
//             const lastVal = Number(data.weeks[lastWeek] || 0);
//             const prevVal = Number(data.weeks[prevWeek] || 0);
            
//             result.DIFF = (lastVal - prevVal).toFixed(2);
//             result.MOM = prevVal === 0 
//                 ? (lastVal > 0 ? "100.00" : "0.00")
//                 : ((lastVal - prevVal) / prevVal * 100).toFixed(2);
            
//             return result;
//         })
//         .filter(item => weeksList.some(week => parseFloat(item[`Week ${week}`]) > 0))
//         .sort((a, b) => a.ItemName.localeCompare(b.ItemName));
// };

// const transformBranchData = (data, startDate, endDate, areaCode, category, division) => {
//     const start = dayjs(startDate);
//     const end = dayjs(endDate);
    
//     // Create week mapping
//     const dateToWeekMap = {};
//     let currentWeek = 1;
//     let weekStartDate = start;
    
//     while (weekStartDate.isBefore(end) || weekStartDate.isSame(end, 'day')) {
//         const weekEndDate = weekStartDate.add(6, 'day');
//         let currentDate = weekStartDate;
//         while ((currentDate.isBefore(weekEndDate) || currentDate.isSame(weekEndDate, 'day')) && 
//                (currentDate.isBefore(end) || currentDate.isSame(end, 'day'))) {
//             dateToWeekMap[currentDate.format('YYYY-MM-DD')] = currentWeek;
//             currentDate = currentDate.add(1, 'day');
//         }
//         weekStartDate = weekStartDate.add(7, 'day');
//         currentWeek++;
//     }

//     const maxWeek = currentWeek - 1;
//     const weeksList = Array.from({ length: maxWeek }, (_, i) => i + 1);

//     // Define channel mapping and corresponding sales channels
//     const channelToSalesChannels = {
//         "Online": ["APP", "WEB"],
//         "Offline": ["POS", "CAL"],
//         "GT / MT": ["GT", "MT"],
//         "MP": ["MP"]
//     };

//     // Filter data based on area, division, and sales channel category
//     const filteredData = data.filter(item => {
//         const matchesArea = item.Area === areaCode;
//         const matchesDivision = division === "ALL" ? true : 
//             division === "PRODUCT" ? item.Division === "PRODUCT" :
//             item.Division === division;
//         const matchesChannel = channelToSalesChannels[category]?.includes(item.SalesChannel);

//         return matchesArea && matchesDivision && matchesChannel;
//     });

//     const groupedData = filteredData.reduce((acc, item) => {
//         const businessDate = dayjs(item.BusinessDate);
//         const formattedBusinessDate = businessDate.format('YYYY-MM-DD');
//         const weekNum = dateToWeekMap[formattedBusinessDate];
        
//         if (!weekNum) return acc;

//         const key = `${item.BranchName}-${item.SalesChannel}`;
        
//         if (!acc[key]) {
//             acc[key] = {
//                 BranchName: item.BranchName,
//                 SalesChannel: item.SalesChannel,
//                 Division: item.Division,
//                 weeks: {}
//             };
//         }
        
//         const qty = parseFloat(item.Qty) || 0;
//         const returnQty = parseFloat(item.ReturnQty) || 0;
//         const netQty = Math.max(0, qty - returnQty);
        
//         acc[key].weeks[weekNum] = (acc[key].weeks[weekNum] || 0) + netQty;
        
//         return acc;
//     }, {});

//     return Object.values(groupedData)
//         .map(data => {
//             const result = {
//                 BranchName: data.BranchName,
//                 SalesChannel: data.SalesChannel,
//                 Division: data.Division
//             };
            
//             weeksList.forEach(weekNum => {
//                 result[`Week ${weekNum}`] = Number(data.weeks[weekNum] || 0).toFixed(2);
//             });
            
//             const lastWeek = maxWeek;
//             const prevWeek = lastWeek - 1;
//             const lastVal = Number(data.weeks[lastWeek] || 0);
//             const prevVal = Number(data.weeks[prevWeek] || 0);
            
//             result.DIFF = (lastVal - prevVal).toFixed(2);
//             result.MOM = prevVal === 0 
//                 ? (lastVal > 0 ? "100.00" : "0.00")
//                 : ((lastVal - prevVal) / prevVal * 100).toFixed(2);
            
//             return result;
//         })
//         .filter(item => weeksList.some(week => parseFloat(item[`Week ${week}`]) > 0))
//         .sort((a, b) => a.BranchName.localeCompare(b.BranchName));
// };


    

    

//     useEffect(() => {
//         const fetchAreas = async () => {
//             setAreasLoading(true);
//             setError(null);

//             try {
//                 const response = await fetch(`${local_url}/api/SFArea/${userId}`);
//                 if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//                 const data = await response.json();
//                 setAreas(Array.isArray(data) ? data : []);
//             } catch (error) {
//                 setError(`Failed to fetch areas: ${error.message}`);
//             } finally {
//                 setAreasLoading(false);
//             }
//         };

//         fetchAreas();
//     }, [local_url, userId]);

//     const fetchReportData = async () => {
//         setExpandedAreas([]);
//         setExpandedData({});
//         setExpandedKeys([]);
//         setExpandedBranchKeys([]);
//         setExpandedItemData({});
        
//         setLoading(true);
//         setError(null);
    
//         const token = localStorage.getItem('AuthorizationToken');
//         if (!token) {
//             handleLogout("Authorization token not found. Please login again.");
//             return;
//         }
    
//         try {
//             const formattedStartDate = startDate.format('YYYYMMDD');
//             const formattedEndDate = endDate.format('YYYYMMDD');
    
//             const url = `${local_signage}/api/v1/b2csaleqty?Option=LIST&AreaID=${area}&SaleChannel=${type}&StartDate=${formattedStartDate}&EndDate=${formattedEndDate}`;
    
//             const response = await fetch(url, {
//                 headers: {
//                     'Accept': 'application/json',
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//             });
    
//             if (response.status === 401) {
//                 handleLogout("Session expired. Please login again.");
//                 return;
//             }

//             else if (response.status === 403) {
//                 handleLogout("Session expired. Please login again.");
//                 return;
//             }
    
//             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            
//             const data = await response.json();
//             setRawData(data);
//             const transformedData = transformWeeklyData(data, startDate, endDate);
//             setTableData(transformedData);
//             setPage(1);
    
//         } catch (error) {
//             setError(error.message || "Failed to fetch report data");
//         } finally {
//             setLoading(false);
//         }
//     };
    
//     const handleLogout = (message) => {
//         // Clear all localStorage items
//         localStorage.clear();
        
//         // Show alert with the message
//         alert(message);
        
//         // Redirect to login page
//         window.location.href = '/login';  // Adjust this path based on your routing setup
        
//         // Set loading to false
//         setLoading(false);
//     };

    




//     useEffect(() => {
//         const fetchAreas = async () => {
//             setAreasLoading(true);
//             setError(null);

//             try {
//                 const response = await fetch(`${local_url}/api/SFArea/${userId}`);
//                 if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//                 const data = await response.json();
//                 setAreas(Array.isArray(data) ? data : []);
//             } catch (error) {
//                 setError(`Failed to fetch areas: ${error.message}`);
//             } finally {
//                 setAreasLoading(false);
//             }
//         };

//         fetchAreas();
//     }, [local_url, userId]);



//     const getChannelCategory = (salesChannel) => {
//         const channelMapping = {
//             "APP": "Online",
//             "WEB": "Online",
//             "POS": "Offline",
//             "CAL": "Offline",
//             "GT": "GT / MT",
//             "MT": "GT / MT",
//             "MP": "MP"
//         };
//         return channelMapping[salesChannel] || "Others";
//     };

//     // In the render section, update the branch rows rendering:
//     const renderBranchRows = (compositeKey, item) => {
//         if (!expandedAreas.includes(compositeKey)) return [];
        
//         const branchData = expandedData[compositeKey] || [];
        
//         return branchData.map((branch, idx) => (
//             <tr key={`branch-${compositeKey}-${idx}`} className="branch-row">
//                 <td style={{ paddingLeft: '2rem' }}>
//                     {branch.BranchName} - {branch.BranchName}
//                 </td>
//                 {selectedDivision === "ALL" && (
//                     <td>{branch.Division === "PRODUCT" ? "PACKED" : branch.Division}</td>
//                 )}
//                 <td>{branch.SalesChannel}</td>
//                 {Object.keys(branch)
//                     .filter(key => key.startsWith('Week '))
//                     .map(week => (
//                         <td key={week}>{branch[week]}</td>
//                     ))
//                 }
//                 <td className={Number(branch.DIFF) >= 0 ? 'text-success' : 'text-danger'}>
//                     {branch.DIFF}
//                 </td>
//                 <td className={Number(branch.MOM) >= 0 ? 'text-success' : 'text-danger'}>
//                     {branch.MOM}
//                 </td>
//             </tr>
//         ));
//     };



 
    



//     const handleAreaClick = async (areaCode) => {
//         const isExpanded = expandedAreas.includes(areaCode);
//         if (isExpanded) {
//             setExpandedAreas(prev => prev.filter(a => a !== areaCode));
//         } else {
//             const branchData = transformBranchData(rawData, startDate, endDate, areaCode);
//             setExpandedData(prev => ({
//                 ...prev,
//                 [areaCode]: branchData
//             }));
//             setExpandedAreas(prev => [...prev, areaCode]);
//         }
//     };



//     const handleRowClick = async (areaCode, category, division) => {
//         const compositeKey = `${areaCode}-${category}-${division}`;
//         const isExpanded = expandedKeys.includes(compositeKey);
        
//         if (isExpanded) {
//             setExpandedKeys(prev => prev.filter(k => k !== compositeKey));
//         } else {
//             const branchData = transformBranchData(rawData, startDate, endDate, areaCode, category, division);
//             setExpandedData(prev => ({
//                 ...prev,
//                 [compositeKey]: branchData
//             }));
//             setExpandedKeys(prev => [...prev, compositeKey]);
//         }
//     };
    



//     const handleExport = () => {
//         if (!rawData || !rawData.length) return;
    
//         // Get date range for the report period
//         const start = dayjs(startDate);
//         const end = dayjs(endDate);
        
//         // Create week mapping for all dates in range
//         const dateToWeekMap = {};
//         let currentWeek = 1;
//         let weekStartDate = start;
        
//         while (weekStartDate.isBefore(end) || weekStartDate.isSame(end, 'day')) {
//             const weekEndDate = weekStartDate.add(6, 'day');
//             let currentDate = weekStartDate;
            
//             while ((currentDate.isBefore(weekEndDate) || currentDate.isSame(weekEndDate, 'day')) && 
//                    (currentDate.isBefore(end) || currentDate.isSame(end, 'day'))) {
//                 dateToWeekMap[currentDate.format('YYYY-MM-DD')] = currentWeek;
//                 currentDate = currentDate.add(1, 'day');
//             }
            
//             weekStartDate = weekStartDate.add(7, 'day');
//             currentWeek++;
//         }
        
//         const maxWeek = currentWeek - 1;
//         const weekColumns = Array.from({ length: maxWeek }, (_, i) => `Week ${i + 1}`);
    
//         // Initialize data structure for aggregation
//         const aggregatedData = {};
    
//         // Filter and aggregate data
//         rawData
//             .filter(record => {
//                 // Apply division filter
//                 if (selectedDivision !== "ALL") {
//                     return record.Division === selectedDivision;
//                 }
//                 return true;
//             })
//             .forEach(record => {
//                 const businessDate = dayjs(record.BusinessDate);
//                 const weekNum = dateToWeekMap[businessDate.format('YYYY-MM-DD')];
                
//                 if (!weekNum) return; // Skip if date is outside range
    
//                 const qty = parseFloat(record.Qty) || 0;
//                 const returnQty = parseFloat(record.ReturnQty) || 0;
//                 const netQty = Math.max(0, qty - returnQty);
    
//                 // Create a unique key for each combination
//                 const key = `${record.Area}|${record.AreaName}|${record.Division}|${record.SalesChannel}|${record.BranchName}|${record.BranchName}|${record.itemname}`;
    
//                 if (!aggregatedData[key]) {
//                     aggregatedData[key] = {
//                         AreaCode: record.Area,
//                         AreaName: record.AreaName,
//                         Division: record.Division,
//                         SalesChannel: record.SalesChannel,
//                         BranchName: record.BranchName,
//                         BranchName: record.BranchName,
//                         ItemName: record.itemname,
//                         weeks: {}
//                     };
//                 }
    
//                 aggregatedData[key].weeks[weekNum] = (aggregatedData[key].weeks[weekNum] || 0) + netQty;
//             });
    
//         // Prepare CSV content
//         let csvContent = [];
    
//         // Add report metadata
//         csvContent.push([`Weekly Sales Report - ${selectedDivision} Division`]);
//         csvContent.push([`Period: ${start.format('DD MMM YYYY')} to ${end.format('DD MMM YYYY')}`]);
//         csvContent.push([`Generated on: ${dayjs().format('DD MMM YYYY HH:mm:ss')}`]);
//         csvContent.push([`Division: ${selectedDivision}`]);
//         csvContent.push([`Area: ${area}`]);
//         csvContent.push([`Sales Channel: ${type}`]);
//         csvContent.push([]); // Empty line for spacing
    
//         // Add headers - Now including Division
//         const headers = [
//             'Area Code',
//             'Area Name',
//             'Division', // Added Division header
//             'Sales Channel',
//             'Branch ID',
//             'Branch Name',
//             'Item Name',
//             ...weekColumns.map(week => {
//                 const weekNum = parseInt(week.split(' ')[1]);
//                 const weekStart = start.add((weekNum - 1) * 7, 'day').format('DD MMM');
//                 const weekEnd = start.add(weekNum * 7 - 1, 'day').format('DD MMM');
//                 return `${week}\n(${weekStart}-${weekEnd})`
//             }),
//             'Total Quantity',
//             'Week over Week Change',
//             'WoW %'
//         ];
//         csvContent.push(headers);
    
//         // Transform aggregated data into rows
//         Object.values(aggregatedData)
//             .sort((a, b) => {
//                 // Sort by Area, Division, Branch, and Item
//                 if (a.AreaName !== b.AreaName) return a.AreaName.localeCompare(b.AreaName);
//                 if (a.Division !== b.Division) return a.Division.localeCompare(b.Division);
//                 if (a.BranchName !== b.BranchName) return a.BranchName.localeCompare(b.BranchName);
//                 if (a.SalesChannel !== b.SalesChannel) return a.SalesChannel.localeCompare(b.SalesChannel);
//                 return a.ItemName.localeCompare(b.ItemName);
//             })
//             .forEach(item => {
//                 // Calculate totals and changes
//                 let totalQty = 0;
//                 const weeklyQtys = weekColumns.map(week => {
//                     const weekNum = parseInt(week.split(' ')[1]);
//                     const qty = item.weeks[weekNum] || 0;
//                     totalQty += qty;
//                     return qty.toFixed(2);
//                 });
    
//                 // Calculate Week over Week changes
//                 const lastWeekQty = Number(item.weeks[maxWeek] || 0);
//                 const prevWeekQty = Number(item.weeks[maxWeek - 1] || 0);
                
//                 const wowChange = (lastWeekQty - prevWeekQty).toFixed(2);
//                 const wowPercentage = ((lastWeekQty - prevWeekQty) / (prevWeekQty || 1) * 100).toFixed(2);
                
//                 // Create row - Now including Division
//                 const row = [
//                     item.AreaCode,
//                     item.AreaName,
//                     item.Division === "PRODUCT" ? "PACKED" : item.Division, // Format Division display
//                     item.SalesChannel,
//                     item.BranchName,
//                     item.BranchName,
//                     item.ItemName,
//                     ...weeklyQtys,
//                     totalQty.toFixed(2),
//                     wowChange,
//                     wowPercentage
//                 ];
//                 csvContent.push(row);
//             });
    
//         // Add total row
//         const totalRow = calculateTotalRow(aggregatedData, weekColumns, maxWeek);
//         csvContent.push([]);  // Empty row for spacing
//         csvContent.push(totalRow);
    
//         // Convert to CSV string with proper escaping
//         const csvString = csvContent
//             .map(row => row.map(cell => {
//                 if (cell === null || cell === undefined) return '';
//                 const cellStr = cell.toString();
//                 if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
//                     return `"${cellStr.replace(/"/g, '""')}"`;
//                 }
//                 return cellStr;
//             }).join(','))
//             .join('\n');
    
//         // Generate filename
//         const timestamp = dayjs().format('YYYYMMDD_HHmmss');
//         const fileName = `${selectedDivision}_Weekly_Sales_${start.format('YYYYMMDD')}_${end.format('YYYYMMDD')}_${timestamp}.csv`;
    
//         // Create and download file
//         const blob = new Blob(['\ufeff' + csvString], { type: 'text/csv;charset=utf-8;' });
//         saveAs(blob, fileName);
//     };
    
//     // Helper function to calculate total row
//     const calculateTotalRow = (aggregatedData, weekColumns, maxWeek) => {
//         const weekTotals = {};
//         let grandTotal = 0;
    
//         Object.values(aggregatedData).forEach(item => {
//             weekColumns.forEach((week, index) => {
//                 const weekNum = index + 1;
//                 const qty = item.weeks[weekNum] || 0;
//                 weekTotals[weekNum] = (weekTotals[weekNum] || 0) + qty;
//                 grandTotal += qty;
//             });
//         });
    

//         const lastWeek = maxWeek;
//         const prevWeek = maxWeek - 1;
//         const lastWeekTotal = weekTotals[lastWeek] || 0;
//         const prevWeekTotal = weekTotals[prevWeek] || 0;
//         const wowChange = (lastWeekTotal - prevWeekTotal).toFixed(2);
//         const wowPercentage = prevWeekTotal === 0 
//             ? (lastWeekTotal > 0 ? '100.00' : '0.00')
//             : ((lastWeekTotal - prevWeekTotal) / prevWeekTotal * 100).toFixed(2);


//         return [
//             '',             // Area Code
//             'Grand Total',  // Area Name
//             '',             // Sales Channel
//             '',             // Branch ID
//             '',             // Branch Name
//             '',             // Item Name
//             ...weekColumns.map(week => {
//                 const weekNum = parseInt(week.split(' ')[1]);
//                 return (weekTotals[weekNum] || 0).toFixed(2);
//             }),
//             grandTotal.toFixed(2),
//             wowChange,
//             wowPercentage
//         ];
//     };
    
//     // Helper function to calculate totals



//     const handlePageChange = (event, newPage) => {
//         setPage(newPage);
//     };

//     const startIndex = (page - 1) * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     const paginatedData = tableData.slice(startIndex, endIndex);

//     return (
//       <div className="report-container">
//           <Header />
//           <Card className="report-card">
//               <CardContent>
//                   <Grid container spacing={2} alignItems="center" justifyContent="space-between">
//                       <Grid item xs={12} sm={6} md={2}>
//                           <FormControl fullWidth>
//                               <InputLabel>Area</InputLabel>
//                               <Select
//                                   value={area}
//                                   onChange={(e) => setArea(e.target.value)}
//                                   label="Area"
//                                   disabled={areasLoading}
//                               >
//                                   <MenuItem value="ALL">ALL</MenuItem>
//                                   {areas.map((area) => (
//                                       <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
//                                           {area.sfAreaName}
//                                       </MenuItem>
//                                   ))}
//                               </Select>
//                           </FormControl>
//                       </Grid>


//                       <Grid item xs={12} sm={6} md={2}>
//   <LocalizationProvider dateAdapter={AdapterDayjs}>
//     <DatePicker
//       label="Start Date"
//       value={startDate}
//       onChange={handleStartDateChange}
//       format="DD-MM-YYYY"
//       maxDate={endDate} // Cannot be after the selected End Date
//       shouldDisableDate={(date) =>
//         endDate && date.isBefore(dayjs(endDate).subtract(35, "days"))
//       }
//       slotProps={{
//         textField: {
//           fullWidth: true,
//           error: !!error,
//         },
//       }}
//       renderDay={(day, _value, pickersProps) => {
//         const isWithinLimit =
//           endDate &&
//           day.isAfter(dayjs(endDate).subtract(36, "days")) &&
//           day.isBefore(dayjs(endDate).add(1, "day"));

//         return (
//           <Tooltip title={isWithinLimit ? "Within 35-day limit" : "Out of range"}>
//             <span
//               {...pickersProps}
//               style={{
//                 backgroundColor: isWithinLimit ? "lightgreen" : "transparent",
//                 borderRadius: "50%",
//                 padding: "5px",
//               }}
//             >
//               {day.format("D")}
//             </span>
//           </Tooltip>
//         );
//       }}
//     />
//   </LocalizationProvider>
// </Grid>
                      
                    
// <Grid item xs={12} sm={6} md={2}>
//   <LocalizationProvider dateAdapter={AdapterDayjs}>
//     <DatePicker
//       label="End Date"
//       value={endDate}
//       onChange={handleEndDateChange}
//       format="DD-MM-YYYY"
//       maxDate={today}
//       slotProps={{
//         textField: {
//           fullWidth: true,
//           error: !!error,
//         },
//       }}
//       renderDay={(day, _value, pickersProps) => {
//         return (
//           <Tooltip title="Select End Date">
//             <span {...pickersProps}>{day.format("D")}</span>
//           </Tooltip>
//         );
//       }}
//     />
//   </LocalizationProvider>
// </Grid>


//                       <Grid item xs={12} sm={6} md={2}>
//                           <FormControl fullWidth>
//                               <InputLabel>Division</InputLabel>
//                               <Select
//                                   value={selectedDivision}
//                                   onChange={(e) => setSelectedDivision(e.target.value)}
//                                   label="Division"
//                               >
//                                   <MenuItem value="ALL">ALL</MenuItem>
//                                   <MenuItem value="POULTRY">POULTRY</MenuItem>
//                                   <MenuItem value="EGG">EGG</MenuItem>
//                                   <MenuItem value="PRODUCT">PACKED</MenuItem>
//                                   <MenuItem value="NONPOULTRY">NONPOULTRY</MenuItem>
//                                   <MenuItem value="RTC">RTC</MenuItem>
//                               </Select>
//                           </FormControl>
//                       </Grid>

//                       {/* Search Button */}
//                       <Grid item xs={12} sm={6} md={1.6}>
//                       <Button 
//             variant="contained" 
//             color="primary" 
//             fullWidth 
//             onClick={fetchReportData}
//             disabled={!isValidRange}
//           >
//             Search
//           </Button>
//                       </Grid>

//                       {/* Export Button */}
//                       <Grid item xs={12} sm={6} md={1.6}>
//                           <Button variant="contained" color="secondary" fullWidth onClick={handleExport}>
//                               Export
//                           </Button>
//                       </Grid>
//                   </Grid>

//                   {error && <div className="error-message">{error}</div>}

//                   <div className="report-table-container">
//                       <div style={{ padding: '6px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
//                           <strong>Note: Poultry items are measured by weight (KG), while eggs and non-poultry items are measured by quantity (NOS). GT/MT & MP includes returns till End Date.</strong>
//                       </div>

//                       <div className="report-table-scroll">
//   <table className="report-table">
//       <thead>
//           <tr>
//               <th style={{ minWidth: '180px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>Area</th>
//               {selectedDivision === "ALL" && (
//                   <th style={{ minWidth: '100px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>Division</th>
//               )}
//               <th style={{ minWidth: '120px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>Channel</th>
//               {paginatedData.length > 0 && Object.keys(paginatedData[0])
//                   .filter(key => key.startsWith('Week '))
//                   .map(week => {
//                       const weekNum = parseInt(week.split(' ')[1]);
//                       const weekStart = startDate.add((weekNum - 1) * 7, 'day').format('DD/MM');
//                       const weekEnd = weekNum * 7 > endDate.diff(startDate, 'day') + 1
//                           ? endDate.format('DD/MM')
//                           : startDate.add(weekNum * 7 - 1, 'day').format('DD/MM');
//                       return (
//                           <th key={week} style={{ minWidth: '120px', textAlign: 'left', verticalAlign: 'middle', padding: '8px', whiteSpace: 'nowrap' }}>
//                               <div style={{ marginBottom: '4px' }}>{week}</div>
//                               <div style={{ fontSize: '0.85em', color: '#666', fontWeight: 'normal' }}>
//                                   ({weekStart} - {weekEnd})
//                               </div>
//                           </th>
//                       );
//                   })
//               }
//               <th style={{ minWidth: '100px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>DIFF</th>
//               <th style={{ minWidth: '100px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>WOW (%)</th>
//           </tr>
//       </thead>
//       <tbody>
//   {loading ? (
//       <tr>
//           <td colSpan={selectedDivision === "ALL" ? 9 : 8} className="report-loading">
//               <CircularProgress />
//           </td>
//       </tr>
//   ) : paginatedData.length > 0 ? (
//       paginatedData.flatMap((item, index) => {
//           const compositeKey = `${item.CITYID}-${item.Category}-${item.Division}`;
//           const isExpanded = expandedKeys.includes(compositeKey);
//           const branchData = expandedData[compositeKey] || [];

//           const areaRow = (
//               <tr key={`area-${index}`}
//                   onClick={() => handleRowClick(item.CITYID, item.Category, item.Division)}
//                   style={{
//                       cursor: 'pointer',
//                       alignItems: 'start',
//                       backgroundColor: isExpanded ? '#f0f0f0' : 'inherit',
//                       fontWeight: 600
//                   }}>
//                   <td>
//                       {isExpanded ? '▼ ' : '▶ '}
//                       {item.AREANAME}
//                   </td>
//                   {selectedDivision === "ALL" && (
//                       <td>{item.Division === "PRODUCT" ? "PACKED" : item.Division}</td>
//                   )}
//                   <td>{item.Category}</td>
//                   {Object.keys(item)
//                       .filter(key => key.startsWith('Week '))
//                       .map(week => (
//                           <td key={week}>{item[week]}</td>
//                       ))}
//                   <td className={Number(item.DIFF) >= 0 ? 'text-success' : 'text-danger'}>
//                       {item.DIFF}
//                   </td>
//                   <td className={Number(item.MOM) >= 0 ? 'text-success' : 'text-danger'}>
//                       {item.MOM}
//                   </td>
//               </tr>
//           );

//           const branchRows = isExpanded ? branchData.map((branch, idx) => {
//               const branchCompositeKey = `${branch.BranchName}-${branch.SalesChannel}-${item.CITYID}-${item.Category}-${item.Division}`;
//               const isBranchExpanded = expandedBranchKeys.includes(branchCompositeKey);
//               const itemData = expandedItemData[branchCompositeKey] || [];

//               return (
//                   <React.Fragment key={`branch-${index}-${idx}`}>
//   <tr
//       onClick={(e) => {
//           e.stopPropagation();
//           handleBranchClick(branch.BranchName, branch.SalesChannel, item.CITYID, item.Category, item.Division); // Pass division here
//       }}
//       style={{
//           backgroundColor: '#f8f9fa',
//           cursor: 'pointer'
//       }}>
//       <td style={{ paddingLeft: '20px' }}>
//           {isBranchExpanded ? '▼ ' : '▶ '}
//           {branch.BranchName}
//       </td>
//       {selectedDivision === "ALL" && (
//           <td>{item.Division === "PRODUCT" ? "PACKED" : item.Division}</td>  
//       )}
//       <td>{branch.SalesChannel}</td>
//       {Object.keys(branch)
//           .filter(key => key.startsWith('Week '))
//           .map(week => (
//               <td key={week}>{branch[week]}</td>
//           ))}
//       <td className={Number(branch.DIFF) >= 0 ? 'text-success' : 'text-danger'}>
//           {branch.DIFF}
//       </td>
//       <td className={Number(branch.MOM) >= 0 ? 'text-success' : 'text-danger'}>
//           {branch.MOM}
//       </td>
//   </tr>

//   {/* Item rows */}
//   {isBranchExpanded && itemData.map((item, itemIdx) => (
//       <tr key={`item-${index}-${idx}-${itemIdx}`} style={{
//           backgroundColor: '#fff',
//           borderLeft: '3px solid #dee2e6'
//       }}>
//           <td style={{ paddingLeft: '40px', fontStyle: 'italic' }}>
//               {item.ItemName}
//           </td>
//           {selectedDivision === "ALL" && (
//           <td>{item.Division === "PRODUCT" ? "PACKED" : item.Division}</td>  
//       )}
//           <td>{item.SalesChannel}</td>
//           {Object.keys(item)
//               .filter(key => key.startsWith('Week '))
//               .map(week => (
//                   <td key={week}>{item[week]}</td>
//               ))}
//           <td className={Number(item.DIFF) >= 0 ? 'text-success' : 'text-danger'}>
//               {item.DIFF}
//           </td>
//           <td className={Number(item.MOM) >= 0 ? 'text-success' : 'text-danger'}>
//               {item.MOM}
//           </td>
//       </tr>
//   ))}
// </React.Fragment>

//               );
//           }) : [];

//           return [areaRow, ...branchRows];
//       })
//   ) : (
//       <tr>
//           <td colSpan={selectedDivision === "ALL" ? 9 : 8} className="report-no-data">
//               No data available
//           </td>
//       </tr>
//   )}
// </tbody>
//   </table>
// </div>

//                       {tableData.length > 0 && (
//                           <div className="report-pagination">
//                               <div className="report-pagination-info">
//                                   Showing {startIndex + 1} to {Math.min(endIndex, tableData.length)} of {tableData.length} entries
//                               </div>
//                               <Pagination
//                                   count={Math.ceil(tableData.length / rowsPerPage)}
//                                   page={page}
//                                   onChange={handlePageChange}
//                                   color="primary"
//                                   shape="rounded"
//                               />
//                           </div>
//                       )}
//                   </div>
//               </CardContent>
//           </Card>
//       </div>
//   );
// };

// export default SaleWeeklySummary;

































import React, { useState, useEffect } from "react";
import { Header } from "../../Header";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import Pagination from "@mui/material/Pagination";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import "../Reports.css";
import { local_signage, local_url } from "../../Const";
import { saveAs } from "file-saver";
import { Tooltip } from "@mui/material";
import "./weeklyreport.css";
dayjs.extend(isoWeek);

const SaleWeeklySummary = () => {
    const [areas, setAreas] = useState([]);
    const [area, setArea] = useState("ALL");
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [type, setType] = useState("ALL");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [error, setError] = useState(null);
    const [areasLoading, setAreasLoading] = useState(true);
    const userId = localStorage.getItem('userId');
    const rowsPerPage = 200;
    const [selectedDivision, setSelectedDivision] = useState("POULTRY");
    const [expandedAreas, setExpandedAreas] = useState([]);
    const [expandedData, setExpandedData] = useState({});
    const [rawData, setRawData] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [expandedBranchKeys, setExpandedBranchKeys] = useState([]);
    const [expandedItemData, setExpandedItemData] = useState({});
    const [isValidRange, setIsValidRange] = useState(true);
    const [highlightedDays, setHighlightedDays] = useState([]);
    const today = dayjs();


    const transformWeeklyData = (data, startDate, endDate) => {
        if (!Array.isArray(data) || data.length === 0) return [];
        
        const start = dayjs(startDate);
        const end = dayjs(endDate);
        
        // Create week mapping
        const dateToWeekMap = {};
        let currentWeek = 1;
        let weekStartDate = start;
        
        while (weekStartDate.isBefore(end) || weekStartDate.isSame(end, 'day')) {
            const weekEndDate = weekStartDate.add(6, 'day');
            
            let currentDate = weekStartDate;
            while ((currentDate.isBefore(weekEndDate) || currentDate.isSame(weekEndDate, 'day')) && 
                   (currentDate.isBefore(end) || currentDate.isSame(end, 'day'))) {
                dateToWeekMap[currentDate.format('YYYY-MM-DD')] = currentWeek;
                currentDate = currentDate.add(1, 'day');
            }
            
            weekStartDate = weekStartDate.add(7, 'day');
            currentWeek++;
        }
        
        const maxWeek = currentWeek - 1;
        const weeksList = Array.from({ length: maxWeek }, (_, i) => i + 1);
        
        const channelMapping = {
            "APP": "Online",
            "WEB": "Online",
            "POS": "Offline",
            "CAL": "Offline",
            "GT": "GT / MT",
            "MT": "GT / MT",
            "MP": "MP",
            "HORECA": "HORECA"
        };
    
        // Update division display
        const formatDivision = (division) => {
            switch(division) {
                case "PRODUCT": return "PACKED";
                case "RTC": return "RTC";
                default: return division;
            }
        };
        
        // Filter data based on division and type (sales channel)
        const filteredData = data.filter(item => {
            const divisionMatch = selectedDivision === "ALL" ? true : 
                selectedDivision === "PRODUCT" ? item.Division === "PRODUCT" :
                selectedDivision === "NONPOULTRY" ? item.Division === "NONPOULTRY" :
                item.Division === selectedDivision;
    
            const channelCategory = channelMapping[item.SalesChannel] || "Others";
            const channelMatch = type === "ALL" ? true : 
                type === "Online" ? ["APP", "WEB"].includes(item.SalesChannel) :
                type === "Offline" ? ["POS", "CAL"].includes(item.SalesChannel) :
                type === "GT / MT" ? ["GT", "MT"].includes(item.SalesChannel) :
                type === "HORECA" ? item.SalesChannel === "HORECA" :
                type === item.SalesChannel;
    
            return divisionMatch && channelMatch;
        });
        
        // Group data by area, division, and category
        const groupedData = filteredData.reduce((acc, item) => {
            const businessDate = dayjs(item.BusinessDate);
            const formattedBusinessDate = businessDate.format('YYYY-MM-DD');
            const weekNum = dateToWeekMap[formattedBusinessDate];
            
            if (!weekNum) return acc;
            
            const division = item.Division;
            const category = channelMapping[item.SalesChannel] || "Others";
            const key = selectedDivision === "ALL" 
                ? `${item.Area}-${division}-${category}`
                : `${item.Area}-${category}`;
            
            if (!acc[key]) {
                acc[key] = {
                    CITYID: item.Area,
                    AREANAME: item.AreaName,
                    Division: division,
                    Category: category,
                    weeks: {},
                    itemDetails: {}
                };
            }
            
            const qty = parseFloat(item.Qty) || 0;
            const returnQty = parseFloat(item.ReturnQty) || 0;
            const netQty = Math.max(0, qty - returnQty);
            
            // Aggregate by week
            acc[key].weeks[weekNum] = (acc[key].weeks[weekNum] || 0) + netQty;
            
            // Track individual item details for potential drill-down
            const itemKey = `${item.ItemId}-${item.itemname}`;
            if (!acc[key].itemDetails[itemKey]) {
                acc[key].itemDetails[itemKey] = {
                    weeks: {},
                    itemname: item.itemname,
                    ItemId: item.ItemId
                };
            }
            acc[key].itemDetails[itemKey].weeks[weekNum] = 
                (acc[key].itemDetails[itemKey].weeks[weekNum] || 0) + netQty;
            
            return acc;
        }, {});
    
        // Transform grouped data into final result
        return Object.values(groupedData)
            .map(data => {
                const result = {
                    CITYID: data.CITYID,
                    AREANAME: data.AREANAME,
                    Division: formatDivision(data.Division),
                    Category: data.Category,
                };
                
                // Populate weeks
                weeksList.forEach(weekNum => {
                    result[`Week ${weekNum}`] = Number(data.weeks[weekNum] || 0).toFixed(2);
                });
                
                // Calculate differences and mom
                const lastWeek = Math.max(...weeksList);
                const prevWeek = lastWeek - 1;
                
                const lastVal = Number(data.weeks[lastWeek] || 0);
                const prevVal = Number(data.weeks[prevWeek] || 0);
                
                result.DIFF = (lastVal - prevVal).toFixed(2);
                
                // Improved MoM calculation
                if (prevVal === 0) {
                    result.MOM = lastVal > 0 ? "100.00" : "0.00";
                } else {
                    result.MOM = ((lastVal - prevVal) / prevVal * 100).toFixed(2);
                }
                
                return result;
            })
            .filter(item => weeksList.some(week => parseFloat(item[`Week ${week}`]) > 0))
            .sort((a, b) => {
                // Sorting logic for divisions
                if (selectedDivision === "ALL") {
                    const divisionOrder = { 
                        "POULTRY": 1, 
                        "EGG": 2, 
                        "NONPOULTRY": 3, 
                        "PACKED": 4,
                        "RTC": 5 
                    };
                    if (a.Division !== b.Division) {
                        return divisionOrder[a.Division] - divisionOrder[b.Division];
                    }
                }
                if (a.AREANAME !== b.AREANAME) {
                    return a.AREANAME.localeCompare(b.AREANAME);
                }
                if (a.Category === "Online" && b.Category !== "Online") return -1;
                if (b.Category === "Online" && a.Category !== "Online") return 1;
                
                const categoryOrder = { "Online": 1, "Offline": 2, "GT / MT": 3, "MP": 4, "HORECA": 5 };
                return categoryOrder[a.Category] - categoryOrder[b.Category];
            });
    };



    

    const validateDateRange = (start, end) => {
        // If either start or end is not a valid dayjs object, return invalid
        if (!start || !end || !dayjs.isDayjs(start) || !dayjs.isDayjs(end)) {
          return {
            isValid: false,
            error: 'Invalid date selection'
          };
        }
      
        const today = dayjs();
        const daysDifference = end.diff(start, 'day');
      
        // Check if end date is after today
        if (end.isAfter(today)) {
          return {
            isValid: false,
            error: 'End date cannot be later than today'
          };
        }
      
        // Check if date range exceeds 35 days
        if (daysDifference > 35) {
          return {
            isValid: false,
            error: 'Date range cannot exceed 35 days'
          };
        }
      
        // Check if start date is after end date
        if (start.isAfter(end)) {
          return {
            isValid: false,
            error: 'Start date cannot be after end date'
          };
        }
      
        // If all checks pass, return valid
        return {
          isValid: true,
          error: ''
        };
      };
      
      // Updated useEffect to set validation state
      useEffect(() => {
        const validation = validateDateRange(startDate, endDate);
        setIsValidRange(validation.isValid);
        // Optionally set error if you want to show error messages
        setError(validation.error);
      }, [startDate, endDate]);
      
      // Modified change handlers
      const handleStartDateChange = (newValue) => {
        if (dayjs.isDayjs(newValue) && newValue.isValid()) {
          setStartDate(newValue);
          const validation = validateDateRange(newValue, endDate);
          setIsValidRange(validation.isValid);
          setError(validation.error);
        }
      };
      
      const handleEndDateChange = (newValue) => {
        if (dayjs.isDayjs(newValue) && newValue.isValid()) {
          setEndDate(newValue);
          const validation = validateDateRange(startDate, newValue);
          setIsValidRange(validation.isValid);
          setError(validation.error);
        }
      };



  // Function to transform the API response data into the format expected by your existing code
  function transformApiResponse(groupSaleData, materialData, branchData, areaData) {
    // Create efficient lookup maps for faster matching
    const materialMap = new Map(
        materialData.map(material => [material.ItemId, material])
    );
    
    const branchMap = new Map(
        branchData.map(branch => [branch.Branchid, branch])
    );
    
    const areaMap = new Map(
        areaData.map(area => [area.Area, area])
    );

    return groupSaleData.map(sale => {
        // Find material info using ItemId
        let materialInfo = materialMap.get(sale.ItemId);

        // Fetch additional context
        const branchInfo = branchMap.get(sale.Branchid) || {};
        const areaInfo = areaMap.get(sale.Area) || {};

        // Enhanced date parsing with robust handling
        const parseDate = (dateStr) => {
            try {
                return dateStr.replace(
                    /(\d{4})(\d{2})(\d{2})/, 
                    '$1-$2-$3'
                );
            } catch (error) {
                console.warn(`Date parsing error for ${dateStr}`, error);
                return dateStr; // Return original if parsing fails
            }
        };

        // Determine Division with explicit PRODUCT to PACKED conversion
        const determineDivision = () => {
            const division = sale.Division || 'OTHERS';
            return division === "PRODUCT" ? "PACKED" : division;
        };

        // Sanitize and validate quantities
        const sanitizeQuantity = (qty) => {
            const parsedQty = parseFloat(qty);
            return isNaN(parsedQty) ? 0 : Math.max(0, parsedQty);
        };

        return {
            Area: sale.Area,
            AreaName: areaInfo.SFAreaName || 'Unknown Area',
            BranchName: branchInfo.BranchName || 'Unknown Branch',
            BusinessDate: parseDate(sale.BusinessDate),
            SalesChannel: sale.SalesChannel,
            Division: determineDivision(),
            ItemId: sale.ItemId,
            itemname: (materialInfo && materialInfo.MaterialName) || 'Unknown Item',
            Qty: sanitizeQuantity(sale.Qty),
            ReturnQty: sanitizeQuantity(sale.ReturnQty),
            GroupType: sale.grp || 'UNSPECIFIED',
            ItemFamilyId: (materialInfo && materialInfo.MaterialFamilyId) || 'UNKNOWN'
        };
    }).filter(item => 
        // Optional: Filter out entries with zero quantity or problematic data
        item.Qty > 0 || item.ReturnQty > 0
    );
}
  
  // Usage:

  const calculateTotal = (item) => {
    return Object.keys(item)
      .filter(key => key.startsWith('Week '))
      .reduce((sum, week) => {
        const value = parseFloat(item[week]) || 0;
        return sum + value;
      }, 0).toFixed(2);
  };


// Updated handleBranchClick function
const handleBranchClick = (BranchName, salesChannel, areaCode, category, division) => {
    const compositeKey = `${BranchName}-${salesChannel}-${areaCode}-${category}-${division}`;
    
    const isExpanded = expandedBranchKeys.includes(compositeKey);
    
    if (isExpanded) {
        setExpandedBranchKeys(prev => prev.filter(k => k !== compositeKey));
    } else {
        const itemData = transformItemData(
            rawData, 
            startDate, 
            endDate, 
            BranchName, 
            salesChannel, 
            areaCode, 
            category, 
            division
        );
        
        setExpandedItemData(prev => ({
            ...prev,
            [compositeKey]: itemData
        }));
        setExpandedBranchKeys(prev => [...prev, compositeKey]);
    }
};

// Updated transformItemData function

const transformItemData = (data, startDate, endDate, BranchName, salesChannel, areaCode, category, division) => {
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    
    // Create week mapping
    const dateToWeekMap = {};
    let currentWeek = 1;
    let weekStartDate = start;
    
    while (weekStartDate.isBefore(end) || weekStartDate.isSame(end, 'day')) {
        const weekEndDate = weekStartDate.add(6, 'day');
        let currentDate = weekStartDate;
        while ((currentDate.isBefore(weekEndDate) || currentDate.isSame(weekEndDate, 'day')) && 
               (currentDate.isBefore(end) || currentDate.isSame(end, 'day'))) {
            dateToWeekMap[currentDate.format('YYYY-MM-DD')] = currentWeek;
            currentDate = currentDate.add(1, 'day');
        }
        weekStartDate = weekStartDate.add(7, 'day');
        currentWeek++;
    }

    const maxWeek = currentWeek - 1;
    const weeksList = Array.from({ length: maxWeek }, (_, i) => i + 1);

    // Filter data based on all criteria
    const filteredData = data.filter(item => {
        const matchesBranch = item.BranchName === BranchName;
        const matchesChannel = item.SalesChannel === salesChannel;
        const matchesArea = item.Area === areaCode;
        const matchesDivision = division === "ALL" ? true : 
            division === "PRODUCT" ? item.Division === "PRODUCT" :
            item.Division === division;

        return matchesBranch && matchesChannel && matchesArea && matchesDivision;
    });

    const groupedData = filteredData.reduce((acc, item) => {
        const businessDate = dayjs(item.BusinessDate);
        const formattedBusinessDate = businessDate.format('YYYY-MM-DD');
        const weekNum = dateToWeekMap[formattedBusinessDate];
        
        if (!weekNum) return acc;

        const key = `${item.ItemId}-${item.itemname}`;
        
        if (!acc[key]) {
            acc[key] = {
                ItemName: item.itemname,
                ItemId: item.ItemId,
                Division: item.Division,
                SalesChannel: item.SalesChannel,
                weeks: {}
            };
        }
        
        const qty = parseFloat(item.Qty) || 0;
        const returnQty = parseFloat(item.ReturnQty) || 0;
        const netQty = Math.max(0, qty - returnQty);
        
        acc[key].weeks[weekNum] = (acc[key].weeks[weekNum] || 0) + netQty;
        
        return acc;
    }, {});

    return Object.values(groupedData)
        .map(data => {
            const result = {
                ItemName: data.ItemName,
                ItemId: data.ItemId,
                Division: data.Division,
                SalesChannel: data.SalesChannel
            };
            
            weeksList.forEach(weekNum => {
                result[`Week ${weekNum}`] = Number(data.weeks[weekNum] || 0).toFixed(2);
            });
            
            const lastWeek = maxWeek;
            const prevWeek = lastWeek - 1;
            const lastVal = Number(data.weeks[lastWeek] || 0);
            const prevVal = Number(data.weeks[prevWeek] || 0);
            
            result.DIFF = (lastVal - prevVal).toFixed(2);
            result.MOM = prevVal === 0 
                ? (lastVal > 0 ? "100.00" : "0.00")
                : ((lastVal - prevVal) / prevVal * 100).toFixed(2);
            
            return result;
        })
        .filter(item => weeksList.some(week => parseFloat(item[`Week ${week}`]) > 0))
        .sort((a, b) => a.ItemName.localeCompare(b.ItemName));
};

const transformBranchData = (data, startDate, endDate, areaCode, category, division) => {
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    
    // Create week mapping
    const dateToWeekMap = {};
    let currentWeek = 1;
    let weekStartDate = start;
    
    while (weekStartDate.isBefore(end) || weekStartDate.isSame(end, 'day')) {
        const weekEndDate = weekStartDate.add(6, 'day');
        let currentDate = weekStartDate;
        while ((currentDate.isBefore(weekEndDate) || currentDate.isSame(weekEndDate, 'day')) && 
               (currentDate.isBefore(end) || currentDate.isSame(end, 'day'))) {
            dateToWeekMap[currentDate.format('YYYY-MM-DD')] = currentWeek;
            currentDate = currentDate.add(1, 'day');
        }
        weekStartDate = weekStartDate.add(7, 'day');
        currentWeek++;
    }

    const maxWeek = currentWeek - 1;
    const weeksList = Array.from({ length: maxWeek }, (_, i) => i + 1);

    // Define channel mapping and corresponding sales channels
    const channelToSalesChannels = {
        "Online": ["APP", "WEB"],
        "Offline": ["POS", "CAL"],
        "GT / MT": ["GT", "MT"],
        "MP": ["MP"],
        "HORECA": ["HORECA"]
    };

    // Filter data based on area, division, and sales channel category
    const filteredData = data.filter(item => {
        const matchesArea = item.Area === areaCode;
        const matchesDivision = division === "ALL" ? true : 
            division === "PRODUCT" ? item.Division === "PRODUCT" :
            item.Division === division;
        const matchesChannel = channelToSalesChannels[category]?.includes(item.SalesChannel);

        return matchesArea && matchesDivision && matchesChannel;
    });

    const groupedData = filteredData.reduce((acc, item) => {
        const businessDate = dayjs(item.BusinessDate);
        const formattedBusinessDate = businessDate.format('YYYY-MM-DD');
        const weekNum = dateToWeekMap[formattedBusinessDate];
        
        if (!weekNum) return acc;

        const key = `${item.BranchName}-${item.SalesChannel}`;
        
        if (!acc[key]) {
            acc[key] = {
                BranchName: item.BranchName,
                SalesChannel: item.SalesChannel,
                Division: item.Division,
                weeks: {}
            };
        }
        
        const qty = parseFloat(item.Qty) || 0;
        const returnQty = parseFloat(item.ReturnQty) || 0;
        const netQty = Math.max(0, qty - returnQty);
        
        acc[key].weeks[weekNum] = (acc[key].weeks[weekNum] || 0) + netQty;
        
        return acc;
    }, {});

    return Object.values(groupedData)
        .map(data => {
            const result = {
                BranchName: data.BranchName,
                SalesChannel: data.SalesChannel,
                Division: data.Division
            };
            
            weeksList.forEach(weekNum => {
                result[`Week ${weekNum}`] = Number(data.weeks[weekNum] || 0).toFixed(2);
            });
            
            const lastWeek = maxWeek;
            const prevWeek = lastWeek - 1;
            const lastVal = Number(data.weeks[lastWeek] || 0);
            const prevVal = Number(data.weeks[prevWeek] || 0);
            
            result.DIFF = (lastVal - prevVal).toFixed(2);
            result.MOM = prevVal === 0 
                ? (lastVal > 0 ? "100.00" : "0.00")
                : ((lastVal - prevVal) / prevVal * 100).toFixed(2);
            
            return result;
        })
        .filter(item => weeksList.some(week => parseFloat(item[`Week ${week}`]) > 0))
        .sort((a, b) => a.BranchName.localeCompare(b.BranchName));
};


    

    

    useEffect(() => {
        const fetchAreas = async () => {
            setAreasLoading(true);
            setError(null);

            try {
                const response = await fetch(`${local_url}/api/SFArea/${userId}`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                setAreas(Array.isArray(data) ? data : []);
            } catch (error) {
                setError(`Failed to fetch areas: ${error.message}`);
            } finally {
                setAreasLoading(false);
            }
        };

        fetchAreas();
    }, [local_url, userId]);
    const fetchReportData = async () => {
        setExpandedAreas([]);
        setExpandedData({});
        setExpandedKeys([]);
        setExpandedBranchKeys([]);
        setExpandedItemData({});
        
        setLoading(true);
        setError(null);
    
        const token = localStorage.getItem('AuthorizationToken');
        if (!token) {
            handleLogout("Authorization token not found. Please login again.");
            return;
        }
    
        try {
            const formattedStartDate = startDate.format('YYYYMMDD');
            const formattedEndDate = endDate.format('YYYYMMDD');
    
            const url = `${local_signage}/api/v1/b2csaleqty?Option=LIST&AreaID=${area}&SaleChannel=${type}&StartDate=${formattedStartDate}&EndDate=${formattedEndDate}`;
    
            const response = await fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
    
            if (response.status === 401 || response.status === 403) {
                handleLogout("Session expired. Please login again.");
                return;
            }
    
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            
            const data = await response.json();
            
            // Extract the arrays from the API response
            const groupSaleData = data.groupSale || [];
            const materialData = data.material || [];
            const branchData = data.branch || [];
            const areaData = data.area || [];
            
            // Transform the API response to match expected format
            const transformedData = transformApiResponse(
                groupSaleData, 
                materialData, 
                branchData, 
                areaData
            );
            
            setRawData(transformedData);
            const processedData = transformWeeklyData(transformedData, startDate, endDate);
            setTableData(processedData);
            setPage(1);
    
        } catch (error) {
            setError(error.message || "Failed to fetch report data");
        } finally {
            setLoading(false);
        }
    };
    
    // Define the transformation function

    
    const handleLogout = (message) => {
        // Clear all localStorage items
        localStorage.clear();
        
        // Show alert with the message
        alert(message);
        
        // Redirect to login page
        window.location.href = '/login';  // Adjust this path based on your routing setup
        
        // Set loading to false
        setLoading(false);
    };

    




    useEffect(() => {
        const fetchAreas = async () => {
            setAreasLoading(true);
            setError(null);

            try {
                const response = await fetch(`${local_url}/api/SFArea/${userId}`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                setAreas(Array.isArray(data) ? data : []);
            } catch (error) {
                setError(`Failed to fetch areas: ${error.message}`);
            } finally {
                setAreasLoading(false);
            }
        };

        fetchAreas();
    }, [local_url, userId]);



    const getChannelCategory = (salesChannel) => {
        const channelMapping = {
            "APP": "Online",
            "WEB": "Online",
            "POS": "Offline",
            "CAL": "Offline",
            "GT": "GT / MT",
            "MT": "GT / MT",
            "MP": "MP",
            "HORECA": "HORECA"
        };
        return channelMapping[salesChannel] || "Others";
    };

    // In the render section, update the branch rows rendering:
    const renderBranchRows = (compositeKey, item) => {
        if (!expandedAreas.includes(compositeKey)) return [];
        
        const branchData = expandedData[compositeKey] || [];
        
        return branchData.map((branch, idx) => (
            <tr key={`branch-${compositeKey}-${idx}`} className="branch-row">
                <td style={{ paddingLeft: '2rem' }}>
                    {branch.BranchName} - {branch.BranchName}
                </td>
                {selectedDivision === "ALL" && (
                    <td>{branch.Division === "PRODUCT" ? "PACKED" : branch.Division}</td>
                )}
                <td>{branch.SalesChannel}</td>
                {Object.keys(branch)
                    .filter(key => key.startsWith('Week '))
                    .map(week => (
                        <td key={week}>{branch[week]}</td>
                    ))
                }
                <td className={Number(branch.DIFF) >= 0 ? 'text-success' : 'text-danger'}>
                    {branch.DIFF}
                </td>
                <td className={Number(branch.MOM) >= 0 ? 'text-success' : 'text-danger'}>
                    {branch.MOM}
                </td>
            </tr>
        ));
    };



 
    



    const handleAreaClick = async (areaCode) => {
        const isExpanded = expandedAreas.includes(areaCode);
        if (isExpanded) {
            setExpandedAreas(prev => prev.filter(a => a !== areaCode));
        } else {
            const branchData = transformBranchData(rawData, startDate, endDate, areaCode);
            setExpandedData(prev => ({
                ...prev,
                [areaCode]: branchData
            }));
            setExpandedAreas(prev => [...prev, areaCode]);
        }
    };



    const handleRowClick = async (areaCode, category, division) => {
        const compositeKey = `${areaCode}-${category}-${division}`;
        const isExpanded = expandedKeys.includes(compositeKey);
        
        if (isExpanded) {
            setExpandedKeys(prev => prev.filter(k => k !== compositeKey));
        } else {
            const branchData = transformBranchData(rawData, startDate, endDate, areaCode, category, division);
            setExpandedData(prev => ({
                ...prev,
                [compositeKey]: branchData
            }));
            setExpandedKeys(prev => [...prev, compositeKey]);
        }
    };
    



    const handleExport = () => {
        if (!rawData || !rawData.length) return;
    
        // Get date range for the report period
        const start = dayjs(startDate);
        const end = dayjs(endDate);
        
        // Create week mapping for all dates in range
        const dateToWeekMap = {};
        let currentWeek = 1;
        let weekStartDate = start;
        
        while (weekStartDate.isBefore(end) || weekStartDate.isSame(end, 'day')) {
            const weekEndDate = weekStartDate.add(6, 'day');
            let currentDate = weekStartDate;
            
            while ((currentDate.isBefore(weekEndDate) || currentDate.isSame(weekEndDate, 'day')) && 
                   (currentDate.isBefore(end) || currentDate.isSame(end, 'day'))) {
                dateToWeekMap[currentDate.format('YYYY-MM-DD')] = currentWeek;
                currentDate = currentDate.add(1, 'day');
            }
            
            weekStartDate = weekStartDate.add(7, 'day');
            currentWeek++;
        }
        
        const maxWeek = currentWeek - 1;
        const weekColumns = Array.from({ length: maxWeek }, (_, i) => `Week ${i + 1}`);
    
        // Initialize data structure for aggregation
        const aggregatedData = {};
    
        // Comprehensive filter and aggregation
        rawData
            .filter(record => {
                // Apply division and channel filters
                const divisionMatch = selectedDivision === "ALL" || record.Division === selectedDivision;
                const channelMatch = type === "ALL" || getChannelCategory(record.SalesChannel) === type;
                return divisionMatch && channelMatch;
            })
            .forEach(record => {
                const businessDate = dayjs(record.BusinessDate);
                const weekNum = dateToWeekMap[businessDate.format('YYYY-MM-DD')];
                
                if (!weekNum) return; // Skip if date is outside range
    
                const qty = parseFloat(record.Qty) || 0;
                const returnQty = parseFloat(record.ReturnQty) || 0;
                const netQty = Math.max(0, qty - returnQty);
    
                // More granular unique key
                const key = `${record.Area}|${record.AreaName}|${record.Division}|${record.SalesChannel}|${record.BranchName}|${record.itemname}|${record.ItemId}`;
    
                if (!aggregatedData[key]) {
                    aggregatedData[key] = {
                        AreaCode: record.Area,
                        AreaName: record.AreaName,
                        Division: record.Division,
                        SalesChannel: record.SalesChannel,
                        BranchName: record.BranchName,
                        ItemName: record.itemname,
                        ItemId: record.ItemId,
                        weeks: {}
                    };
                }
    
                aggregatedData[key].weeks[weekNum] = (aggregatedData[key].weeks[weekNum] || 0) + netQty;
            });
    
        // Prepare CSV content with more detailed metadata
        let csvContent = [];
    
        // Comprehensive report metadata
        csvContent.push([`Weekly Sales Detailed Export`]);
        csvContent.push([`Period: ${start.format('DD MMM YYYY')} to ${end.format('DD MMM YYYY')}`]);
        csvContent.push([`Generated on: ${dayjs().format('DD MMM YYYY HH:mm:ss')}`]);
        csvContent.push([`Division: ${selectedDivision}`]);
        csvContent.push([`Area: ${area}`]);
        csvContent.push([`Sales Channel: ${type}`]);
        csvContent.push([]); // Spacing
    
        // Enhanced headers
        const headers = [
          'Area Code', 
          'Area Name', 
          'Division', 
          'Sales Channel', 
          'Branch Name', 
          'Item ID',
          'Item Name',
          'Total Quantity', // Add Total column here, before Week columns
          ...weekColumns.map(week => {
              const weekNum = parseInt(week.split(' ')[1]);
              const weekStart = start.add((weekNum - 1) * 7, 'day').format('DD MMM');
              const weekEnd = start.add(weekNum * 7 - 1, 'day').format('DD MMM');
              return `${week}\n(${weekStart}-${weekEnd})`
          }),
          'Week over Week Change',
          'WoW Change %'
      ];
        csvContent.push(headers);
    
        // Transform and filter aggregated data
        const sortedData = Object.values(aggregatedData)
        .filter(item => {
            // Only include rows with non-zero total quantity
            const totalQty = Object.values(item.weeks).reduce((sum, qty) => sum + qty, 0);
            return totalQty > 0;
        })
        .sort((a, b) => {
            // Comprehensive multi-level sorting with null safety
            const compareFields = [
                'AreaName', 
                'Division', 
                'SalesChannel', 
                'BranchName', 
                'ItemName'
            ];
    
            for (let field of compareFields) {
                const valueA = a[field] ?? ''; // Use nullish coalescing to default to empty string
                const valueB = b[field] ?? ''; // Use nullish coalescing to default to empty string
                
                // Compare with explicit null checks
                if (valueA == null && valueB == null) continue;
                if (valueA == null) return 1;
                if (valueB == null) return -1;
                
                const comparison = valueA.localeCompare(valueB);
                if (comparison !== 0) return comparison;
            }
            return 0;
        });
    
        // Process and add rows
        sortedData.forEach(item => {
          let totalQty = 0;
          const weeklyQtys = weekColumns.map(week => {
              const weekNum = parseInt(week.split(' ')[1]);
              const qty = item.weeks[weekNum] || 0;
              totalQty += qty;
              return qty.toFixed(2);
          });
    
            // Calculate Week over Week changes
            const lastWeekQty = Number(item.weeks[maxWeek] || 0);
            const prevWeekQty = Number(item.weeks[maxWeek - 1] || 0);
            
            const wowChange = (lastWeekQty - prevWeekQty).toFixed(2);
            const wowPercentage = ((lastWeekQty - prevWeekQty) / (prevWeekQty || 1) * 100).toFixed(2);
            
            const row = [
              item.AreaCode,
              item.AreaName,
              item.Division === "PRODUCT" ? "PACKED" : item.Division,
              item.SalesChannel,
              item.BranchName,
              item.ItemId,
              item.ItemName,
              totalQty.toFixed(2), // Add total here
              ...weeklyQtys,
              wowChange,
              wowPercentage
          ];
          csvContent.push(row);
      });

    
        // Add total row for non-zero data
        const totalRow = calculateTotalRow(
            Object.fromEntries(
                Object.entries(aggregatedData)
                    .filter(([_, item]) => 
                        Object.values(item.weeks).reduce((sum, qty) => sum + qty, 0) > 0
                    )
            ), 
            weekColumns, 
            maxWeek
        );
        csvContent.push([]);  // Spacing
        csvContent.push(totalRow);
    
        // CSV generation with proper escaping
        const csvString = csvContent
            .map(row => row.map(cell => {
                if (cell === null || cell === undefined) return '';
                const cellStr = cell.toString();
                if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
                    return `"${cellStr.replace(/"/g, '""')}"`;
                }
                return cellStr;
            }).join(','))
            .join('\n');
    
        // Generate filename
        const timestamp = dayjs().format('YYYYMMDD_HHmmss');
        const fileName = `Detailed_Sales_${selectedDivision}_${start.format('YYYYMMDD')}_${end.format('YYYYMMDD')}_${timestamp}.csv`;
    
        // Create and download file
        const blob = new Blob(['\ufeff' + csvString], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, fileName);
    };
    
    // Helper function to calculate total row (unchanged from previous implementation)
    const calculateTotalRow = (aggregatedData, weekColumns, maxWeek) => {
        const weekTotals = {};
        let grandTotal = 0;
    
        Object.values(aggregatedData).forEach(item => {
            weekColumns.forEach((week, index) => {
                const weekNum = index + 1;
                const qty = item.weeks[weekNum] || 0;
                weekTotals[weekNum] = (weekTotals[weekNum] || 0) + qty;
                grandTotal += qty;
            });
        });
    
        const lastWeek = maxWeek;
        const prevWeek = maxWeek - 1;
        const lastWeekTotal = weekTotals[lastWeek] || 0;
        const prevWeekTotal = weekTotals[prevWeek] || 0;
        const wowChange = (lastWeekTotal - prevWeekTotal).toFixed(2);
        const wowPercentage = prevWeekTotal === 0 
            ? (lastWeekTotal > 0 ? '100.00' : '0.00')
            : ((lastWeekTotal - prevWeekTotal) / prevWeekTotal * 100).toFixed(2);
    
            return [
              '',             // Area Code
              'Grand Total',  // Area Name
              '',             // Division
              '',             // Sales Channel
              '',             // Branch ID
              '',             // Branch Name
              '',             // Item Name
              grandTotal.toFixed(2), // Add grand total here
              ...weekColumns.map(week => {
                  const weekNum = parseInt(week.split(' ')[1]);
                  return (weekTotals[weekNum] || 0).toFixed(2);
              }),
              wowChange,
              wowPercentage
          ];
    };
    
    // Helper function to calculate total row

    
    // Helper function to calculate totals



    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const startIndex = (page - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedData = tableData.slice(startIndex, endIndex);

    return (
        <div className="weeklyreport-container">
          <Header />
          <Card className="weeklyreport-card">
            <CardContent>
              <Grid container spacing={2} alignItems="center" justifyContent="space-between" className="weeklyreport-grid-container">
                <Grid item xs={12} sm={6} md={2}>
                  <FormControl fullWidth>
                    <InputLabel>Area</InputLabel>
                    <Select
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                      label="Area"
                      disabled={areasLoading}
                    >
                      <MenuItem value="ALL">ALL</MenuItem>
                      {areas.map((area) => (
                        <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
                          {area.sfAreaName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                                      <Grid item xs={12} sm={6} md={2}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>     <DatePicker
      label="Start Date"
      value={startDate}
      onChange={handleStartDateChange}
      format="DD-MM-YYYY"
      maxDate={endDate} // Cannot be after the selected End Date
      shouldDisableDate={(date) =>
        endDate && date.isBefore(dayjs(endDate).subtract(35, "days"))
      }
      slotProps={{
        textField: {
          fullWidth: true,
          error: !!error,
        },
      }}
      renderDay={(day, _value, pickersProps) => {
        const isWithinLimit =
          endDate &&
          day.isAfter(dayjs(endDate).subtract(36, "days")) &&
          day.isBefore(dayjs(endDate).add(1, "day"));

        return (
          <Tooltip title={isWithinLimit ? "Within 35-day limit" : "Out of range"}>
            <span
              {...pickersProps}
              style={{
                backgroundColor: isWithinLimit ? "lightgreen" : "transparent",
                borderRadius: "50%",
                padding: "5px",
              }}
            >
              {day.format("D")}
            </span>
          </Tooltip>
        );
      }}
    />
  </LocalizationProvider>
</Grid>
                      
                    
<Grid item xs={12} sm={6} md={2}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label="End Date"
      value={endDate}
      onChange={handleEndDateChange}
      format="DD-MM-YYYY"
      maxDate={today}
      slotProps={{
        textField: {
          fullWidth: true,
          error: !!error,
        },
      }}
      renderDay={(day, _value, pickersProps) => {
        return (
          <Tooltip title="Select End Date">
            <span {...pickersProps}>{day.format("D")}</span>
          </Tooltip>
        );
      }}
    />
  </LocalizationProvider>
</Grid>

                <Grid item xs={12} sm={6} md={2}>
                  <FormControl fullWidth>
                    <InputLabel>Division</InputLabel>
                    <Select
                      value={selectedDivision}
                      onChange={(e) => setSelectedDivision(e.target.value)}
                      label="Division"
                    >
                      <MenuItem value="ALL">ALL</MenuItem>
                      <MenuItem value="POULTRY">POULTRY</MenuItem>
                      <MenuItem value="EGG">EGG</MenuItem>
                      <MenuItem value="PACKED">PACKED</MenuItem>
                      <MenuItem value="NONPOULTRY">NONPOULTRY</MenuItem>
                      <MenuItem value="RTC">RTC</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
      
                {/* Search Button */}
                <Grid item xs={12} sm={6} md={1.6}>
                <Button 
  variant="contained" 
  color="primary" 
  fullWidth 
  onClick={fetchReportData}   
  disabled={!isValidRange}
>
  Search
</Button>
                </Grid>
      
                {/* Export Button */}
                <Grid item xs={12} sm={6} md={1.6}>
                  <Button variant="contained" color="secondary" fullWidth onClick={handleExport}>
                    Export
                  </Button>
                </Grid>
              </Grid>
      
              {error && <div className="error-message">{error}</div>}
      
              <div className="weeklyreport-table-container">
                <div className="weeklyreport-note">
                  <strong>Note: Poultry items are measured by weight (KG), while eggs and non-poultry items are measured by quantity (NOS). GT/MT, MP & HORECA includes returns, minus 3 days from End Date.</strong>
                </div>
      
                <div className="weeklyreport-table-scroll">
                  <table className="weeklyreport-table">
                    <thead>
                      
                      <tr>
  <th style={{ minWidth: '180px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>Area</th>
  {selectedDivision === "ALL" && (
    <th style={{ minWidth: '100px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>Division</th>
  )}
  <th style={{ minWidth: '120px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>{selectedDivision === "ALL" ? "Channel" : "Division"}</th>
  <th style={{ minWidth: '120px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>Total</th>
  {paginatedData.length > 0 && Object.keys(paginatedData[0])
    .filter(key => key.startsWith('Week '))
    .map(week => {
                            const weekNum = parseInt(week.split(' ')[1]);
                            const weekStart = startDate.add((weekNum - 1) * 7, 'day').format('DD/MM');
                            const weekEnd = weekNum * 7 > endDate.diff(startDate, 'day') + 1
                              ? endDate.format('DD/MM')
                              : startDate.add(weekNum * 7 - 1, 'day').format('DD/MM');
                            return (
                              <th key={week} style={{ minWidth: '120px', textAlign: 'left', verticalAlign: 'middle', padding: '8px', whiteSpace: 'nowrap' }}>
                                <div style={{ marginBottom: '4px' }}>{week}</div>
                                <div style={{ fontSize: '0.85em', color: '#666', fontWeight: 'normal' }}>
                                  ({weekStart} - {weekEnd})
                                </div>
                              </th>
                            );
                          })
                        }
                        <th style={{ minWidth: '100px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>DIFF</th>
                        <th style={{ minWidth: '100px', textAlign: 'left', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>WOW (%)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={selectedDivision === "ALL" ? 9 : 8} className="weeklyreport-loading">
                            <CircularProgress />
                          </td>
                        </tr>
                      ) : paginatedData.length > 0 ? (
                        paginatedData.flatMap((item, index) => {
                          const compositeKey = `${item.CITYID}-${item.Category}-${item.Division}`;
                          const isExpanded = expandedKeys.includes(compositeKey);
                          const branchData = expandedData[compositeKey] || [];
      
                          const areaRow = (
                            <tr key={`area-${index}`}
                              onClick={() => handleRowClick(item.CITYID, item.Category, item.Division)}
                              style={{
                                cursor: 'pointer',
                                alignItems: 'start',
                                backgroundColor: isExpanded ? '#f0f0f0' : 'inherit',
                                fontWeight: 600
                              }}>
                              <td>
                                {isExpanded ? '▼ ' : '▶ '}
                                {item.AREANAME}
                              </td>
                              {selectedDivision === "ALL" && (
                                <td>{item.Division === "PRODUCT" ? "PACKED" : item.Division}</td>
                              )}
                              <td>{selectedDivision === "ALL" ? item.Category : (item.Division === "PRODUCT" ? "PACKED" : item.Division)}</td>

                              <td>{calculateTotal(item)}</td>

                              {Object.keys(item)
                                .filter(key => key.startsWith('Week '))
                                .map(week => (
                                  <td key={week}>{item[week]}</td>
                                ))}
                              <td className={Number(item.DIFF) >= 0 ? 'weeklyreport-text-success' : 'weeklyreport-text-danger'}>
                                {item.DIFF}
                              </td>
                              <td className={Number(item.MOM) >= 0 ? 'weeklyreport-text-success' : 'weeklyreport-text-danger'}>
                                {item.MOM}
                              </td>
                            </tr>
                          );
      
                          const branchRows = isExpanded ? branchData.map((branch, idx) => {
                            const branchCompositeKey = `${branch.BranchName}-${branch.SalesChannel}-${item.CITYID}-${item.Category}-${item.Division}`;
                            const isBranchExpanded = expandedBranchKeys.includes(branchCompositeKey);
                            const itemData = expandedItemData[branchCompositeKey] || [];
      
                            return (
                              <React.Fragment key={`branch-${index}-${idx}`}>
                                <tr
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleBranchClick(branch.BranchName, branch.SalesChannel, item.CITYID, item.Category, item.Division);
                                  }}
                                  style={{
                                    backgroundColor: '#f8f9fa',
                                    cursor: 'pointer'
                                  }}>
                                  <td style={{ paddingLeft: '20px' }}>
                                    {isBranchExpanded ? '▼ ' : '▶ '}
                                    {branch.BranchName}
                                  </td>
                                  {selectedDivision === "ALL" && (
                                    <td>{item.Division === "PRODUCT" ? "PACKED" : item.Division}</td>
                                  )}
                                  <td>{branch.SalesChannel}</td>
                                  <td>{calculateTotal(branch)}</td>

                                  {Object.keys(branch)
                                    .filter(key => key.startsWith('Week '))
                                    .map(week => (
                                      <td key={week}>{branch[week]}</td>
                                    ))}
                                  <td className={Number(branch.DIFF) >= 0 ? 'weeklyreport-text-success' : 'weeklyreport-text-danger'}>
                                    {branch.DIFF}
                                  </td>
                                  <td className={Number(branch.MOM) >= 0 ? 'weeklyreport-text-success' : 'weeklyreport-text-danger'}>
                                    {branch.MOM}
                                  </td>
                                </tr>
      
                                {/* Item rows */}
                                {isBranchExpanded && itemData.map((item, itemIdx) => (
                                  <tr key={`item-${index}-${idx}-${itemIdx}`} style={{
                                    backgroundColor: '#fff',
                                    borderLeft: '3px solid #dee2e6'
                                  }}>
                                    <td style={{ paddingLeft: '40px', fontStyle: 'italic' }}>
                                      {item.ItemName}
                                    </td>
                                    {selectedDivision === "ALL" && (
                                      <td>{item.Division === "PRODUCT" ? "PACKED" : item.Division}</td>
                                    )}
                                    <td>{item.SalesChannel}</td>
                                    <td>{calculateTotal(item)}</td>

                                    {Object.keys(item)
                                      .filter(key => key.startsWith('Week '))
                                      .map(week => (
                                        <td key={week}>{item[week]}</td>
                                      ))}
                                    <td className={Number(item.DIFF) >= 0 ? 'weeklyreport-text-success' : 'weeklyreport-text-danger'}>
                                      {item.DIFF}
                                    </td>
                                    <td className={Number(item.MOM) >= 0 ? 'weeklyreport-text-success' : 'weeklyreport-text-danger'}>
                                      {item.MOM}
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            );
                          }) : [];
      
                          return [areaRow, ...branchRows];
                        })
                      ) : (
                        <tr>
                          <td colSpan={selectedDivision === "ALL" ? 9 : 8} className="weeklyreport-no-data">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
      
                {tableData.length > 0 && (
                  <div className="weeklyreport-pagination">
                    <div className="weeklyreport-pagination-info">
                      Showing {startIndex + 1} to {Math.min(endIndex, tableData.length)} of {tableData.length} entries
                    </div>
                    <Pagination
                      count={Math.ceil(tableData.length / rowsPerPage)}
                      page={page}
                      onChange={handlePageChange}
                      color="primary"
                      shape="rounded"
                    />
                  </div>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }

export default SaleWeeklySummary;






















// import React, { useState, useEffect } from "react";
// import { Header } from "../../Header";
// import CircularProgress from "@mui/material/CircularProgress";
// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import Grid from "@mui/material/Grid";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import Pagination from "@mui/material/Pagination";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import Button from "@mui/material/Button";
// import "../Reports.css";
// import { local_signage, local_url } from "../../Const";
// import { saveAs } from "file-saver";

// const SaleWeeklySummary = () => {
//     const [areas, setAreas] = useState([]);
//     const [area, setArea] = useState("ALL");
//     const [startDate, setStartDate] = useState(dayjs());
//     const [endDate, setEndDate] = useState(dayjs());
//     const [type, setType] = useState("ALL");
//     const [page, setPage] = useState(1);
//     const [loading, setLoading] = useState(false);
//     const [tableData, setTableData] = useState([]);
//     const [error, setError] = useState(null);
//     const [areasLoading, setAreasLoading] = useState(true);
//     const userId = localStorage.getItem('userId');
//     const rowsPerPage = 200;
//     const [division, setDivision] = useState("POULTRY"); // Add new state for division
//     const [selectedDivision, setSelectedDivision] = useState("POULTRY"); // Current division selection
//     const [appliedDivision, setAppliedDivision] = useState("POULTRY");

//    const transformWeeklyData = (data) => {
//         if (!Array.isArray(data) || data.length === 0) {
//             return [];
//         }
    
//         const filteredData = selectedDivision === "ALL" 
//             ? data 
//             : data.filter(item => item.Division === selectedDivision);
    
//         const channelMapping = {
//             "APP": "Online",
//             "WEB": "Online",
//             "POS": "Offline",
//             "CAL": "Offline",
//             "GT": "GT / MT",
//             "MT": "GT / MT",
//             "MP": "MP"
//         };

//         // Find the maximum week number in the data
//         const maxWeek = Math.max(...data.map(item => parseInt(item.WeekNum) || 0));
    
//         const groupedData = filteredData.reduce((acc, item) => {
//             const division = item.Division;
//             const category = channelMapping[item.SalesChannel] || 'Others';
            
//             const key = selectedDivision === "ALL" 
//                 ? `${item.Area}-${division}-${category}`
//                 : `${item.Area}-${category}`;
    
//             if (!acc[key]) {
//                 acc[key] = {
//                     CITYID: item.Area,
//                     AREANAME: item.AreaName,
//                     Division: division,
//                     Category: category,
//                     weeks: {}
//                 };
//                 // Initialize all weeks up to maxWeek with 0
//                 for (let i = 1; i <= maxWeek; i++) {
//                     acc[key].weeks[i] = 0;
//                 }
//             }
    
//             const weekNum = parseInt(item.WeekNum) || 1;
//             const qty = parseFloat(item.Qty) || 0;
//             const returnQty = parseFloat(item.ReturnQty) || 0;
//             const netQty = Math.max(0, qty - returnQty);
    
//             acc[key].weeks[weekNum] = (acc[key].weeks[weekNum] || 0) + netQty;
    
//             return acc;
//         }, {});
    
//         const transformedData = Object.values(groupedData)
//             .map(data => {
//                 const result = {
//                     CITYID: data.CITYID,
//                     AREANAME: data.AREANAME,
//                     Division: data.Division,
//                     Category: data.Category,
//                 };

//                 // Add all weeks dynamically
//                 for (let i = 1; i <= maxWeek; i++) {
//                     result[`Week ${i}`] = Number(data.weeks[i] || 0).toFixed(2);
//                 }

//                 // Calculate DIFF and MOM using the last two weeks
//                 const lastWeek = Number(data.weeks[maxWeek] || 0);
//                 const previousWeek = Number(data.weeks[maxWeek - 1] || 0);
//                 result.DIFF = (lastWeek - previousWeek).toFixed(2);
//                 result.MOM = previousWeek !== 0 
//                     ? ((lastWeek - previousWeek) / previousWeek * 100).toFixed(2)
//                     : lastWeek > 0 ? '100.00' : '0.00';

//                 return result;
//             })
//             .filter(item => {
//                 return Object.keys(item)
//                     .filter(key => key.startsWith('Week '))
//                     .some(week => parseFloat(item[week]) !== 0);
//             });
    
//         // Sort the transformed data
//         return transformedData.sort((a, b) => {
//             if (selectedDivision === "ALL") {
//                 const divisionOrder = { "POULTRY": 1, "EGG": 2, "NONPOULTRY": 3 };
//                 if (a.Division !== b.Division) {
//                     return divisionOrder[a.Division] - divisionOrder[b.Division];
//                 }
//             }
//             if (a.AREANAME !== b.AREANAME) {
//                 return a.AREANAME.localeCompare(b.AREANAME);
//             }
//             if (a.Category === "Online" && b.Category !== "Online") return -1;
//             if (b.Category === "Online" && a.Category !== "Online") return 1;
        
//             const categoryOrder = { "Online": 1, "Offline": 2, "GT / MT": 3, "MP": 4 };
//             return categoryOrder[a.Category] - categoryOrder[b.Category];
//         });
//     };


    




//     useEffect(() => {
//         const fetchAreas = async () => {
//             setAreasLoading(true);
//             setError(null);

//             try {
//                 const response = await fetch(`${local_url}/api/SFArea/${userId}`);
//                 if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//                 const data = await response.json();
//                 setAreas(Array.isArray(data) ? data : []);
//             } catch (error) {
//                 setError(`Failed to fetch areas: ${error.message}`);
//             } finally {
//                 setAreasLoading(false);
//             }
//         };

//         fetchAreas();
//     }, [local_url, userId]);

//     const fetchReportData = async () => {
//         setLoading(true);
//         setError(null);
//         // Update appliedDivision when search is clicked
//         setAppliedDivision(selectedDivision);

//         const token = localStorage.getItem('AuthorizationToken');
//         if (!token) {
//             setError("Authorization token not found. Please login again.");
//             setLoading(false);
//             return;
//         }

//         try {
//             const formattedStartDate = startDate.format('YYYYMMDD');
//             const formattedEndDate = endDate.format('YYYYMMDD');

//             const url = `${local_signage}/api/v1/b2csaleqty?Option=PIVOT&AreaID=${area}&SaleChannel=${type}&StartDate=${formattedStartDate}&EndDate=${formattedEndDate}`;

//             const response = await fetch(url, {
//                 headers: {
//                     'Accept': 'application/json',
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//             });

//             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//             const data = await response.json();
//             const transformedData = transformWeeklyData(data);
//             setTableData(transformedData);
//             setPage(1); // Reset to first page when new data is loaded

//         } catch (error) {
//             setError(error.message || "Failed to fetch report data");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleExport = () => {
//         if (!tableData.length) return;
    
//         // Get all week columns dynamically from the first row
//         const weekColumns = Object.keys(tableData[0])
//             .filter(key => key.startsWith('Week '));
    
//         // Create headers array dynamically
//         const headers = ['AREANAME'];
//         if (selectedDivision === "ALL") {
//             headers.push('Division');
//         }
//         headers.push('Category');
//         headers.push(...weekColumns); // Add all week columns
//         headers.push('DIFF', 'WOW');
    
//         const csvRows = [
//             headers,
//             ...tableData.map(item => {
//                 const row = [item.AREANAME];
//                 if (selectedDivision === "ALL") {
//                     row.push(item.Division);
//                 }
//                 row.push(item.Category);
                
//                 // Add data for all week columns
//                 weekColumns.forEach(week => {
//                     row.push(item[week]);
//                 });
                
//                 // Add DIFF and MOM
//                 row.push(item.DIFF, item.MOM);
                
//                 return row;
//             })
//         ];
    
//         const csvString = csvRows
//             .map(row => row.map(cell =>
//                 typeof cell === 'string' && cell.includes(',') ? `"${cell}"` : cell
//             ).join(','))
//             .join('\n');
    
//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const fileName = `weekly_report_${startDate.format('YYYYMMDD')}_${endDate.format('YYYYMMDD')}.csv`;
//         saveAs(blob, fileName);
//     };


//     const handlePageChange = (event, newPage) => {
//         setPage(newPage);
//     };

//     const startIndex = (page - 1) * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     const paginatedData = tableData.slice(startIndex, endIndex);

//     return (
//         <div className="report-container">
//             <Header />
//             <Card className="report-card">
//                 <CardContent>
//                     <Grid container spacing={2} alignItems="center" justifyContent="space-between">
//                         <Grid item xs={12} sm={6} md={2}>
//                             <FormControl fullWidth>
//                                 <InputLabel>Area</InputLabel>
//                                 <Select
//                                     value={area}
//                                     onChange={(e) => setArea(e.target.value)}
//                                     label="Area"
//                                     disabled={areasLoading}
//                                 >
//                                     <MenuItem value="ALL">ALL</MenuItem>
//                                     {areas.map((area) => (
//                                         <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
//                                             {area.sfAreaName}
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>
//                         </Grid>
//                         <Grid item xs={12} sm={6} md={2}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <DatePicker
//                                     label="Start Date"
//                                     value={startDate}
//                                     onChange={(newValue) => setStartDate(newValue)}
//                                     format="DD-MM-YYYY" // Ensuring dd-MM-yyyy format
//                                     fullWidth
//                                 />
//                             </LocalizationProvider>
//                         </Grid>
//                         <Grid item xs={12} sm={6} md={2}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <DatePicker
//                                     label="End Date"
//                                     value={endDate}
//                                     onChange={(newValue) => setEndDate(newValue)}
//                                     format="DD-MM-YYYY" // Ensuring dd-MM-yyyy format
//                                     fullWidth
//                                 />
//                             </LocalizationProvider>
//                         </Grid>
//                         <Grid item xs={12} sm={6} md={2}>
//                             <FormControl fullWidth>
//                                 <InputLabel>Division</InputLabel>
//                                 <Select
//                                     value={selectedDivision}
//                                     onChange={(e) => setSelectedDivision(e.target.value)}
//                                     label="Division"
//                                 >
//                                     <MenuItem value="ALL">ALL</MenuItem>
//                                     <MenuItem value="POULTRY">POULTRY</MenuItem>
//                                     <MenuItem value="EGG">EGG</MenuItem>
//                                     <MenuItem value="PRODUCT">PACKED</MenuItem>
//                                     <MenuItem value="NONPOULTRY">NONPOULTRY</MenuItem>
 
//                                 </Select>
//                             </FormControl>
//                         </Grid>

//                         {/* Search Button */}
//                         <Grid item xs={12} sm={6} md={1.6}>
//                             <Button variant="contained" color="primary" fullWidth onClick={fetchReportData}>
//                                 Search
//                             </Button>
//                         </Grid>

//                         {/* Export Button */}
//                         <Grid item xs={12} sm={6} md={1.6}>
//                             <Button variant="contained" color="secondary" fullWidth onClick={handleExport}>
//                                 Export
//                             </Button>
//                         </Grid>
//                     </Grid>

//                     {error && <div className="error-message">{error}</div>}

//                     <div className="report-table-container">
//                         {/* Add units description */}
//                         <div style={{ 
                            
                         
//                             padding: '6px', 
//                             backgroundColor: '#f5f5f5', 
//                             borderRadius: '4px' 
//                         }}>
//                             <strong>Note: POULTRY items are measured in Weight (KG) while EGG and NONPOULTRY items are measured in Quantities (NOS)</strong>
//                             <ul style={{ 
//                                 listStyle: 'none', 
//                                 padding: '0', 
//                                 margin: '5px 0 0 0' 
//                             }}>
                            
//                             </ul>
//                             {/* <strong>Units:</strong>
//                             <ul style={{ 
//                                 listStyle: 'none', 
//                                 padding: '0', 
//                                 margin: '5px 0 0 0' 
//                             }}>
//                                 <li>• POULTRY items are measured in Weight (KG)</li>
//                                 <li>• EGG and NONPOULTRY items are measured in Quantities (NOS)</li>
//                             </ul> */}
//                         </div>

                       
//                         <div className="report-table-scroll">
//                         <table className="report-table">
//                 <thead>
//                     <tr>
//                         <th>Area</th>
//                         {selectedDivision === "ALL" && <th>Division</th>}
//                         <th>Channel</th>
//                         {/* Dynamically render week columns */}
//                         {paginatedData.length > 0 && 
//                             Object.keys(paginatedData[0])
//                                 .filter(key => key.startsWith('Week '))
//                                 .map(week => (
//                                     <th key={week}>{week}</th>
//                                 ))
//                         }
//                         <th>DIFF</th>
//                         <th>WOW (%)</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {loading ? (
//                         <tr>
//                             <td colSpan={selectedDivision === "ALL" ? 9 : 8} className="report-loading">
//                                 <CircularProgress />
//                             </td>
//                         </tr>
//                     ) : paginatedData.length > 0 ? (
//                         paginatedData.map((item, index) => (
//                             <tr key={index}>
//                                 <td>{item.AREANAME}</td>
//                                 {selectedDivision === "ALL" && (
//   <td>{item.Division === "PRODUCT" ? "PACKED" : item.Division}</td>
// )}
//                                 <td>{item.Category}</td>
//                                 {/* Dynamically render week data */}
//                                 {Object.keys(item)
//                                     .filter(key => key.startsWith('Week '))
//                                     .map(week => (
//                                         <td key={week}>{item[week]}</td>
//                                     ))
//                                 }
//                                 <td className={Number(item.DIFF) >= 0 ? 'text-success' : 'text-danger'}>
//                                     {item.DIFF}
//                                 </td>
//                                 <td className={Number(item.MOM) >= 0 ? 'text-success' : 'text-danger'}>
//                                     {item.MOM}
//                                 </td>
//                             </tr>
//                         ))
//                     ) : (
//                         <tr>
//                             <td colSpan={selectedDivision === "ALL" ? 9 : 8} className="report-no-data">
//                                 No data available
//                             </td>
//                         </tr>
//                     )}
//                 </tbody>
//             </table>
//                         </div>
//                         {tableData.length > 0 && (
//                             <div className="report-pagination">
//                                 <div className="report-pagination-info">
//                                     Showing {startIndex + 1} to {Math.min(endIndex, tableData.length)} of {tableData.length} entries
//                                 </div>
//                                 <Pagination
//                                     count={Math.ceil(tableData.length / rowsPerPage)}
//                                     page={page}
//                                     onChange={handlePageChange}
//                                     color="primary"
//                                     shape="rounded"
//                                 />
//                             </div>
//                         )}
//                     </div>
//                 </CardContent>
//             </Card>
//         </div>
//     );
// };

// export default SaleWeeklySummary;




















//0202





// import React, { useState, useEffect } from "react";
// import { Header } from "../../Header";
// import CircularProgress from "@mui/material/CircularProgress";
// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import Grid from "@mui/material/Grid";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import Pagination from "@mui/material/Pagination";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import Button from "@mui/material/Button";
// import "../Reports.css";
// import { local_signage, local_url } from "../../Const";
// import { saveAs } from "file-saver";

// const SaleWeeklySummary = () => {
//     const [areas, setAreas] = useState([]);
//     const [area, setArea] = useState("ALL");
//     const [startDate, setStartDate] = useState(dayjs());
//     const [endDate, setEndDate] = useState(dayjs());
//     const [type, setType] = useState("ALL");
//     const [page, setPage] = useState(1);
//     const [loading, setLoading] = useState(false);
//     const [tableData, setTableData] = useState([]);
//     const [error, setError] = useState(null);
//     const [areasLoading, setAreasLoading] = useState(true);
//     const userId = localStorage.getItem('userId');
//     const rowsPerPage = 200;
//     const [division, setDivision] = useState("POULTRY"); // Add new state for division
//     const [selectedDivision, setSelectedDivision] = useState("POULTRY"); // Current division selection
//     const [appliedDivision, setAppliedDivision] = useState("POULTRY");


//     const transformWeeklyData = (data) => {
//         if (!Array.isArray(data) || data.length === 0) {
//             return [];
//         }
    
//         // Filter data based on selected division
//         const filteredData = selectedDivision === "ALL" 
//             ? data // Keep all data for ALL
//             : data.filter(item => item.Division === selectedDivision); // Filter for specific division
    
//         const channelMapping = {
//             "APP": "Online",
//             "WEB": "Online",
//             "POS": "Offline",
//             "CAL": "Offline",
//             "GT": "GT / MT",
//             "MT": "GT / MT",
//             "MP": "MP"
//         };
    
//         const groupedData = filteredData.reduce((acc, item) => {
//             const division = item.Division;
//             const category = channelMapping[item.SalesChannel] || 'Others';
            
//             // Key includes division only when ALL is selected
//             const key = selectedDivision === "ALL" 
//                 ? `${item.Area}-${division}-${category}`
//                 : `${item.Area}-${category}`;
    
//             if (!acc[key]) {
//                 acc[key] = {
//                     CITYID: item.Area,
//                     Division: division,
//                     Category: category,
//                     weeks: { 1: 0, 2: 0, 3: 0, 4: 0 }
//                 };
//             }
    
//             const weekNum = Math.min(Math.max(parseInt(item.WeekNum) || 1, 1), 4);
//             const qty = parseFloat(item.Qty) || 0;
//             const returnQty = parseFloat(item.ReturnQty) || 0;
//             const netQty = Math.max(0, qty - returnQty);
    
//             acc[key].weeks[weekNum] = (acc[key].weeks[weekNum] || 0) + netQty;
    
//             return acc;
//         }, {});
    
//         // Transform the grouped data into final format
//         const transformedData = Object.values(groupedData)
//             .map(data => ({
//                 CITYID: data.CITYID,
//                 Division: data.Division,
//                 Category: data.Category,
//                 'Week 1': Number(data.weeks[1] || 0).toFixed(2),
//                 'Week 2': Number(data.weeks[2] || 0).toFixed(2),
//                 'Week 3': Number(data.weeks[3] || 0).toFixed(2),
//                 'Week 4': Number(data.weeks[4] || 0).toFixed(2),
//                 DIFF: (Number(data.weeks[4] || 0) - Number(data.weeks[3] || 0)).toFixed(2)
//             }))
//             .filter(item => {
//                 // Remove entries with all zero values
//                 return ['Week 1', 'Week 2', 'Week 3', 'Week 4'].some(
//                     week => parseFloat(item[week]) !== 0
//                 );
//             });
    
//         // Sort the data
//         return transformedData.sort((a, b) => {
//             if (selectedDivision === "ALL") {
//                 // Sort by Division first
//                 const divisionOrder = { "POULTRY": 1, "EGG": 2, "NONPOULTRY": 3 };
//                 if (a.Division !== b.Division) {
//                     return divisionOrder[a.Division] - divisionOrder[b.Division];
//                 }
//             }
        
//             // Sort by CITYID
//             if (a.CITYID !== b.CITYID) {
//                 return a.CITYID.localeCompare(b.CITYID);
//             }
        
//             // Sort by Sales Channel Category (Online > Offline > GT/MT > MP)
//             const categoryOrder = { "Online": 1, "Offline": 2, "GT / MT": 3, "MP": 4 };
//             return categoryOrder[a.Category] - categoryOrder[b.Category];
//         });
        
//     };
    




//     useEffect(() => {
//         const fetchAreas = async () => {
//             setAreasLoading(true);
//             setError(null);

//             try {
//                 const response = await fetch(`${local_url}/api/SFArea/${userId}`);
//                 if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//                 const data = await response.json();
//                 setAreas(Array.isArray(data) ? data : []);
//             } catch (error) {
//                 setError(`Failed to fetch areas: ${error.message}`);
//             } finally {
//                 setAreasLoading(false);
//             }
//         };

//         fetchAreas();
//     }, [local_url, userId]);

//     const fetchReportData = async () => {
//         setLoading(true);
//         setError(null);
//         // Update appliedDivision when search is clicked
//         setAppliedDivision(selectedDivision);

//         const token = localStorage.getItem('AuthorizationToken');
//         if (!token) {
//             setError("Authorization token not found. Please login again.");
//             setLoading(false);
//             return;
//         }

//         try {
//             const formattedStartDate = startDate.format('YYYYMMDD');
//             const formattedEndDate = endDate.format('YYYYMMDD');

//             const url = `${local_signage}/api/v1/b2csaleqty?Option=PIVOT&AreaID=${area}&SaleChannel=${type}&StartDate=${formattedStartDate}&EndDate=${formattedEndDate}`;

//             const response = await fetch(url, {
//                 headers: {
//                     'Accept': 'application/json',
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}`
//                 },
//             });

//             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//             const data = await response.json();
//             const transformedData = transformWeeklyData(data);
//             setTableData(transformedData);
//             setPage(1); // Reset to first page when new data is loaded

//         } catch (error) {
//             setError(error.message || "Failed to fetch report data");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleExport = () => {
//         const headers = ['CITYID'];
//         if (selectedDivision === "ALL") {
//             headers.push('Division');
//         }
//         headers.push(...['Category', 'Week 1', 'Week 2', 'Week 3', 'Week 4', 'DIFF']);
    
//         const csvRows = [
//             headers,
//             ...tableData.map(item => {
//                 const row = [item.CITYID];
//                 if (selectedDivision === "ALL") {
//                     row.push(item.Division);
//                 }
//                 return [...row, item.Category, item['Week 1'], item['Week 2'], 
//                         item['Week 3'], item['Week 4'], item.DIFF];
//             })
//         ];
    
//         const csvString = csvRows
//             .map(row => row.map(cell =>
//                 typeof cell === 'string' && cell.includes(',') ? `"${cell}"` : cell
//             ).join(','))
//             .join('\n');
    
//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const fileName = `weekly_report_${startDate.format('YYYYMMDD')}_${endDate.format('YYYYMMDD')}.csv`;
//         saveAs(blob, fileName);
//     };

//     const handlePageChange = (event, newPage) => {
//         setPage(newPage);
//     };

//     const startIndex = (page - 1) * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     const paginatedData = tableData.slice(startIndex, endIndex);

//     return (
//         <div className="report-container">
//             <Header />
//             <Card className="report-card">
//                 <CardContent>
//                     <Grid container spacing={2} alignItems="center" justifyContent="space-between">
//                         <Grid item xs={12} sm={6} md={3}>
//                             <FormControl fullWidth>
//                                 <InputLabel>Area</InputLabel>
//                                 <Select
//                                     value={area}
//                                     onChange={(e) => setArea(e.target.value)}
//                                     label="Area"
//                                     disabled={areasLoading}
//                                 >
//                                     <MenuItem value="ALL">ALL</MenuItem>
//                                     {areas.map((area) => (
//                                         <MenuItem key={area.sfAreaId} value={area.sfAreaId}>
//                                             {area.sfAreaName}
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>
//                         </Grid>
//                         <Grid item xs={12} sm={6} md={3}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <DatePicker
//                                     label="Start Date"
//                                     value={startDate}
//                                     onChange={(newValue) => setStartDate(newValue)}
//                                     format="DD-MM-YYYY" // Ensuring dd-MM-yyyy format
//                                     fullWidth
//                                 />
//                             </LocalizationProvider>
//                         </Grid>
//                         <Grid item xs={12} sm={6} md={3}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <DatePicker
//                                     label="End Date"
//                                     value={endDate}
//                                     onChange={(newValue) => setEndDate(newValue)}
//                                     format="DD-MM-YYYY" // Ensuring dd-MM-yyyy format
//                                     fullWidth
//                                 />
//                             </LocalizationProvider>
//                         </Grid>
//                         <Grid item xs={12} sm={6} md={3}>
//                             <FormControl fullWidth>
//                                 <InputLabel>Division</InputLabel>
//                                 <Select
//                                     value={selectedDivision}
//                                     onChange={(e) => setSelectedDivision(e.target.value)}
//                                     label="Division"
//                                 >
//                                     <MenuItem value="ALL">ALL</MenuItem>
//                                     <MenuItem value="POULTRY">POULTRY</MenuItem>
//                                     <MenuItem value="EGG">EGG</MenuItem>
//                                     <MenuItem value="NONPOULTRY">NONPOULTRY</MenuItem>
//                                 </Select>
//                             </FormControl>
//                         </Grid>

//                         {/* Search Button */}
//                         <Grid item xs={12} sm={6} md={3}>
//                             <Button variant="contained" color="primary" fullWidth onClick={fetchReportData}>
//                                 Search
//                             </Button>
//                         </Grid>

//                         {/* Export Button */}
//                         <Grid item xs={12} sm={6} md={3}>
//                             <Button variant="contained" color="secondary" fullWidth onClick={handleExport}>
//                                 Export
//                             </Button>
//                         </Grid>
//                     </Grid>

//                     {error && <div className="error-message">{error}</div>}

//                     <div className="report-table-container">
//                         <div className="report-table-scroll">
//                         <table className="report-table">
//     <thead>
//         <tr>
//             <th>Region</th>
//             {/* Always show Division column when ALL is selected */}
//             {selectedDivision === "ALL" && <th>Division</th>}
//             <th>Channel</th>
//             <th>Week 1</th>
//             <th>Week 2</th>
//             <th>Week 3</th>
//             <th>Week 4</th>
//             <th>DIFF</th>
//         </tr>
//     </thead>
//     <tbody>
//         {loading ? (
//             <tr>
//                 <td colSpan={selectedDivision === "ALL" ? 8 : 7} className="report-loading">
//                     <CircularProgress />
//                 </td>
//             </tr>
//         ) : paginatedData.length > 0 ? (
//             paginatedData.map((item, index) => (
//                 <tr key={index}>
//                     <td>{item.CITYID}</td>
//                     {selectedDivision === "ALL" && <td>{item.Division}</td>}
//                     <td>{item.Category}</td>
//                     <td>{item['Week 1']}</td>
//                     <td>{item['Week 2']}</td>
//                     <td>{item['Week 3']}</td>
//                     <td>{item['Week 4']}</td>
//                     <td className={Number(item.DIFF) >= 0 ? 'text-success' : 'text-danger'}>
//                         {item.DIFF}
//                     </td>
//                 </tr>
//             ))
//         ) : (
//             <tr>
//                 <td colSpan={selectedDivision === "ALL" ? 8 : 7} className="report-no-data">
//                     No data available
//                 </td>
//             </tr>
//         )}
//     </tbody>
// </table>
//                         </div>
//                         {tableData.length > 0 && (
//                             <div className="report-pagination">
//                                 <div className="report-pagination-info">
//                                     Showing {startIndex + 1} to {Math.min(endIndex, tableData.length)} of {tableData.length} entries
//                                 </div>
//                                 <Pagination
//                                     count={Math.ceil(tableData.length / rowsPerPage)}
//                                     page={page}
//                                     onChange={handlePageChange}
//                                     color="primary"
//                                     shape="rounded"
//                                 />
//                             </div>
//                         )}
//                     </div>
//                 </CardContent>
//             </Card>
//         </div>
//     );
// };

// export default SaleWeeklySummary;